import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { isEqual, sortBy } from 'lodash';

import { BehaviorSubject, combineLatest, Observable, of, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { isNullOrUndefined } from 'util';
import { formatDate, Month } from '../../global/dates';
import { ColumnDef, CommonConstants, PageNotes, SortInfo, TableHeader } from '../../global/interfaces';
import { AppState } from '../../reducers';
import {
  selectCountrySelected, selectMainFilterSelectedAccount, selectMainFilterSelectedClient,
  selectMainPageNotes, selectStaticData
} from '../../shared/layout/main.selectors';
import { selectAuthUser, selectAuthUserRole, selectAuthUserType } from '../auth/auth.selectors';
import {
  EsgFileDownloadAction,
  LoadEsgAction, LoadEsgsDatesAction, ResetEsgDataAction,
  SetEsgMonthFilterAction, SetEsgYearFilterAction
} from './esg.actions';
import {
  EsgDiversityAndInclusionTable, EsgModernSlaveryTable,
  EsgPdfLinks,
  EsgSdgLevelThreeEnvironmental, EsgSdgLevelThreeSocial, EsgSdgLevelTwo,
  EsgTabExportName,
  EsgTabs, ESG_PDF_HEADER, ESG_UN_DEV_GOALS_HEADER
} from './esg.models';
import {
  selectEsgData, selectEsgHoldingDate, selectEsgDiversityAndInclusion, selectEsgLoading,
  selectEsgModernSlavery,
  selectEsgMonthFilter, selectEsgMonths, selectEsgProxyVoting, selectEsgYearFilter, selectEsgYears,
  selectEsgDate, selectEsgAnalyticsClimateTransitionDataCarbonIntensity,
  selectEsgAnalyticsClimateTransitionCarbonWeight, selectEsgRatings, selectEsgCarbonFootPrint, selectEsgSdgData
} from './esg.selectors';
import { Chart } from '../../shared/charts/charts.class';
import { breakSentenceByWhitespaces, getMinMaxValues, getTickPositions } from '../../shared/utils';
import * as moment from 'moment';
import { DrilldownOptions, PlotOptions, SeriesBarOptions } from 'highcharts';
import { getDataUri } from '../../global/getDataUri';
import { pdfFooter, pdfHeader, pdfStyle } from '../../shared/pdfs/templates';
import { DecimalService } from '../../global/pipes/decimal.pipe';
import { selectConsultants } from '../features.selectors';
import { User } from '../administration/user/user.models';
import { LoadClientConsultantAction } from '../features.actions';

import { TableColumnAlignment } from 'atlas-table';
import { PaginationInfo } from 'atlas-pagination';
import { Actions } from 'atlas-cdk';
import { ToastService } from '../../shared/toaster_/toaster_.service';

const pdfFonts = require('pdfmake/build/vfs_fonts.js');
const pdfMake = require('pdfmake/build/pdfmake.js');
@Component({
  standalone: false,
  selector: 'dsp-esg',
  templateUrl: './esg.component.html',
  styleUrls: ['./esg.component.scss']
})
export class EsgComponent implements OnInit, OnDestroy {

  @ViewChild('esgAnalyticsClimateTransitionDataCarbonIntensity')
  public esgAnalyticsClimateTransitionDataCarbonIntensity: ElementRef;

  @ViewChild('selectEsgAnalyticsClimateTransitionCarbonWeightData')
  public esgAnalyticsClimateTransitionCarbonWeightData: ElementRef;

  @ViewChild('esgCarbonFootPrintChart')
  public esgCarbonFootPrintChart: ElementRef;

  @ViewChild('esgUNDevGoalsChart')
  public esgUNDevGoalsChart: ElementRef;


  public year: number;
  public month: number;
  public message;
  public country;
  public accountId;
  public loading$: Observable<boolean>;
  public showEsgData$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public months$: Observable<Month[]>;
  public years$: Observable<number[]>;
  public date$: Observable<string>;
  public esgDate$: Observable<string>;
  public esgDiversityAndInclusionTable$: Observable<any>;
  public esgModernSlaveryTable$: Observable<any>;
  public esgProxyVotingTable$: Observable<any>;
  public esgRatingTable$: Observable<any>;
  public esgAnalyticsClimateTransitionDataCarbonIntensity$: Observable<any>;
  public esgAnalyticsClimateTransitionCarbonWeightData$: Observable<any>;
  public esgCarbonFootPrintTable$: Observable<any>;
  public esgUNDevGoalsTable$: Observable<any>;

  public notes$: BehaviorSubject<PageNotes> = new BehaviorSubject<PageNotes>({} as PageNotes);
  public sort$: BehaviorSubject<SortInfo> = new BehaviorSubject<SortInfo>({ column: 'name', reverse: false });
  // public pagination$: Observable<PaginationInfo>;
  public pagination$: Observable<PaginationInfo>;

  public selectedTabIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public carbonFootPrintChart$: Observable<Chart>;
  public esgUNDevGoalsChart$: Observable<Chart>;
  public selectedFund$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public levelDrillDown$: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  public sdgLevelThreeType$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public resetChart$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public user$: Observable<User | undefined>;



  private readonly subscription: Subscription = new Subscription();

  // public diversityInclusionHeaders: TableHeader[] = [
  //   {
  //     name: 'Name',
  //     column: 'name',
  //   },
  //   {
  //     name: 'Boards with at least 30% Female Representation - Fund (%)',
  //     column: 'diBoardDiversityFund',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Boards with at least 30% Female Representation - Benchmark (%)',
  //     column: 'diBoardDiversityBenchMark',
  //     textAlign: 'right'
  //   }
  // ];

  // public esgUNDevGoalsHeader: TableHeader[] = [];
  // public slaveryHeader: TableHeader[] = [
  //   {
  //     name: 'Name',
  //     column: 'name',
  //   },
  //   {
  //     name: 'Number of Companies with Red Flags',
  //     column: 'companiesRedFlag',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Percentage of Portfolio in Red Flag Companies (%)',
  //     column: 'porttfolioPercentRedFlag',
  //     textAlign: 'right'
  //   }
  // ];

  // public proxyHeader: TableHeader[] = [
  //   {
  //     name: 'Name',
  //     column: 'name',
  //   },
  //   {
  //     name: 'Number of Meetings Voted - Australia',
  //     column: 'meetingsVotedNumAus',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Percentage of Meetings Voted - Australia (%)',
  //     column: 'meetingsVotedPercentAus',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Number of Meetings Voted - Global ex-Australia',
  //     column: 'meetingsVotedNumGlobalExAus',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Percentage of Meetings Voted - Global ex-Australia (%)',
  //     column: 'meetingsVotedPercentGlobalExAus',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Proportion of Votes Against Management Recommendations - Global (%)',
  //     column: 'votesAgainstManagementRecPercentGlobal',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Number of Supervotes - Global',
  //     column: 'supervotesNumGlobal',
  //     textAlign: 'right'
  //   }
  // ];



  public diversityInclusionHeaders: ColumnDef[] = [
    {
      name: 'Name',
      column: 'name',
      displayLabel: 'Name',
      fieldKey: 'name',
    },
    {
      name: 'Boards with at least 30% Female Representation - Fund (%)',
      column: 'diBoardDiversityFund',
      align: TableColumnAlignment.right,
      displayLabel: 'Boards with at least 30% Female Representation - Fund (%)',
      fieldKey: 'diBoardDiversityFund',

    },
    {
      name: 'Boards with at least 30% Female Representation - Benchmark (%)',
      column: 'diBoardDiversityBenchMark',
      align: TableColumnAlignment.right,
      displayLabel: 'Boards with at least 30% Female Representation - Benchmark (%)',
      fieldKey: 'diBoardDiversityBenchMark',

    }
  ];

  public esgUNDevGoalsHeader: ColumnDef[] = [];
  public slaveryHeader: ColumnDef[] = [
    {
      name: 'Name',
      column: 'name',
      displayLabel: 'Name',
      fieldKey: 'name',
    },
    {
      name: 'Number of Companies with Red Flags',
      column: 'companiesRedFlag',
      align: TableColumnAlignment.right,
      displayLabel: 'Number of Companies with Red Flags',
      fieldKey: 'companiesRedFlag',
    },
    {
      name: 'Percentage of Portfolio in Red Flag Companies (%)',
      column: 'porttfolioPercentRedFlag',
      align: TableColumnAlignment.right,
      displayLabel: 'Percentage of Portfolio in Red Flag Companies (%)',
      fieldKey: 'porttfolioPercentRedFlag',
    }
  ];

  public proxyHeader: ColumnDef[] = [
    {
      name: 'Name',
      column: 'name',
      displayLabel: 'Name',
      fieldKey: 'name',

    },
    {
      name: 'Number of Meetings Voted - Australia',
      column: 'meetingsVotedNumAus',
      align: TableColumnAlignment.right,
      displayLabel: 'Number of Meetings Voted - Australia',
      fieldKey: 'meetingsVotedNumAus',

    },
    {
      name: 'Percentage of Meetings Voted - Australia (%)',
      column: 'meetingsVotedPercentAus',
      align: TableColumnAlignment.right,
      displayLabel: 'Percentage of Meetings Voted - Australia (%)',
      fieldKey: 'meetingsVotedPercentAus',

    },
    {
      name: 'Number of Meetings Voted - Global ex-Australia',
      column: 'meetingsVotedNumGlobalExAus',
      align: TableColumnAlignment.right,
      displayLabel: 'Number of Meetings Voted - Global ex-Australia',
      fieldKey: 'meetingsVotedNumGlobalExAus',


    },
    {
      name: 'Percentage of Meetings Voted - Global ex-Australia (%)',
      column: 'meetingsVotedPercentGlobalExAus',
      align: TableColumnAlignment.right,
      displayLabel: 'Percentage of Meetings Voted - Global ex-Australia (%)',
      fieldKey: 'meetingsVotedPercentGlobalExAus',


    },
    {
      name: 'Proportion of Votes Against Management Recommendations - Global (%)',
      column: 'votesAgainstManagementRecPercentGlobal',
      align: TableColumnAlignment.right,
      displayLabel: 'Proportion of Votes Against Management Recommendations - Global (%)',
      fieldKey: 'votesAgainstManagementRecPercentGlobal',


    },
    {
      name: 'Number of Supervotes - Global',
      column: 'supervotesNumGlobal',
      align: TableColumnAlignment.right,
      displayLabel: 'Number of Supervotes - Global',
      fieldKey: 'supervotesNumGlobal',

    }
  ];


  public esgDiversityText = EsgTabs.diversityInclusion;
  public esgDiversityTooltipText = EsgTabs.diversityInclusionTooltip;
  public esgModernSlaveryText = EsgTabs.modernSlavery;
  public esgHomeText = 'Sustainable Investment';
  public esgProxyText = EsgTabs.proxyVoting;
  public analyticsClimateTransition = 'Analytics for Climate Transition';
  public esgRatingAssessment = EsgTabs.esgRating;
  public esgCarbonFootPrint = EsgTabs.carbonFootprint;
  public esgUNDevGoals = EsgTabs.unDevGoals;
  public headerEsgRating: ColumnDef[] = [];

  public headerEsgCarbonFootPrint: ColumnDef[] = [];

  constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly decimal: DecimalService,
    private readonly _toasterService: ToastService

  ) {
    this.loading$ = this.selectLoading();
    this.years$ = this.selectYears();
    this.months$ = this.selectMonths();
    this.date$ = this.selectDate();
    this.esgDate$ = this.selectEsgDate();
    this.esgDiversityAndInclusionTable$ = this.selectEsgDiversityAndInclusionTable();
    this.esgModernSlaveryTable$ = this.selectEsgModernSlaveryTable();
    this.esgProxyVotingTable$ = this.selectEsgProxyVotingTable();
    this.esgRatingTable$ = this.selectEsgRatingTable();
    this.esgAnalyticsClimateTransitionCarbonWeightData$ = this.selectEsgAnalyticsClimateTransitionCarbonWeightData();
    this.esgAnalyticsClimateTransitionDataCarbonIntensity$ = this.selectEsgAnalyticsClimateTransitionDataCarbonIntensityData();
    this.pagination$ = this.selectPagination();
    this.carbonFootPrintChart$ = this.selectCarbonFootPrintChart();
    this.esgUNDevGoalsChart$ = this.selectEsgUNDevGoalsChart();

    this.esgCarbonFootPrintTable$ = this.selectEsgCarbonFootPrintTable();
    this.esgUNDevGoalsTable$ = this.selectEsgUNDevGoalsTable();
    this.user$ = this.store.pipe(select(selectAuthUser));
  }

  ngOnInit() {
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.subscribeLoadCheck());
    this.subscription.add(this.subscribeLoadEsgDates());
    this.subscription.add(this.subscribeInitialYearFilter());
    this.subscription.add(this.subscribeYearFilter());
    this.subscription.add(this.subscribeInitialMonthFilter());
    this.subscription.add(this.subscribeMonthFilter());
    this.subscription.add(this.subscribeLoadEsg());
    this.subscription.add(this.subscribeConsultantLoad());
    this.subscription.add(this.subscribeSelectedClient());
  }


  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.country = country;
      if (country === 'nz') {
        this.router.navigate(['/overview']);
      }
    });
  }
  private subscribeSelectedClient(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectCountrySelected)),
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectAuthUserRole))
    ]).pipe(
      filter(([client]) => !!client
      ),
      distinctUntilChanged(isEqual),
      map(([client, account, country, selectAuthUserType, selectAuthUserRole]) => ({
        client, account, country, selectAuthUserType, selectAuthUserRole
      }))
    ).subscribe(payload => {
      if (payload.country === 'au') {
        if (payload.selectAuthUserType === 'external' && payload.selectAuthUserRole === 'consultant') {
          if (!payload.client.esg) {
            this.router.navigate(['/overview']);
          }
        }
      }
    });
  }

  private subscribeLoadCheck(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectAuthUserType)),
    //   this.store.pipe(select(selectMainFilterSelectedClient))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectMainFilterSelectedClient))]
    ).pipe(
      distinctUntilChanged(isEqual)
    ).subscribe(([selectAuthUserType, selectedClient]) => {
      this.showEsgData$.next(false);
      if (selectAuthUserType === 'internal') {
        if ((isNullOrUndefined(selectedClient)) || (!isNullOrUndefined(selectedClient)
          && (isNullOrUndefined(selectedClient.esg) || selectedClient.esg === false))) {
          this.message = CommonConstants.esgOffMessage;
        } else {
          this.message = CommonConstants.esgOnMessage;
          this.showEsgData$.next(true);
        }
      } else if ((!isNullOrUndefined(selectedClient)
        && (!isNullOrUndefined(selectedClient.esg) && selectedClient.esg === true))) {
        this.showEsgData$.next(true);
      }
    });
  }

  private subscribeLoadEsgDates(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount))]
    ).pipe(
      distinctUntilChanged(isEqual)
    ).subscribe(([account]) => {
      if (!!account) {
        this.accountId = account._id;
        this.levelDrillDown$.next(0);
        this.store.dispatch(new LoadEsgsDatesAction({ account: account._id }));
      } else {
        this.store.dispatch(new ResetEsgDataAction());
      }
    });
  }

  private subscribeInitialYearFilter(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgYears)),
    //   this.store.pipe(select(selectEsgYearFilter))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgYears)),
      this.store.pipe(select(selectEsgYearFilter))]
    ).pipe(
      filter(([years]) => !!years.length),
      map(([years, year]) => year !== undefined ? year : years[0])
    ).subscribe(year => {
      this.store.dispatch(new SetEsgYearFilterAction(year));
    });
  }

  // private subscribeYearFilter(): Subscription {
  //   return this.store.pipe(
  //     select(selectEsgYearFilter)
  //   ).subscribe(year => {
  //     this.year = year !== undefined ? [year] : [];
  //   });
  // }
  private subscribeYearFilter(): Subscription {
    return this.store.pipe(
      select(selectEsgYearFilter)
    ).subscribe(year => {
      this.year = year !== undefined ? year : undefined;
    });
  }

  private subscribeInitialMonthFilter(): Subscription {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgMonths)),
    //   this.store.pipe(select(selectEsgMonthFilter))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgMonths)),
      this.store.pipe(select(selectEsgMonthFilter))]
    ).pipe(
      filter(([months, month]) => !!months.length && !month),
      map(([months, month]) => month !== undefined ? month : months[months.length - 1].value)
    ).subscribe(month => {
      this.store.dispatch(new SetEsgMonthFilterAction(month));
    });
  }

  // private subscribeMonthFilter(): Subscription {
  //   return this.store.pipe(
  //     select(selectEsgMonthFilter)
  //   ).subscribe(month => {
  //     this.month = month !== undefined ? [month] : [];
  //   });
  // }

  private subscribeMonthFilter(): Subscription {
    return this.store.pipe(
      select(selectEsgMonthFilter)
    ).subscribe(month => {
      this.month = month !== undefined ? month : undefined;
    });
  }

  private selectLoading(): Observable<boolean> {
    return this.store.pipe(
      select(selectEsgLoading)
    );
  }

  private selectDate(): Observable<string> {
    return this.store.pipe(
      select(selectEsgHoldingDate),
      map(date => {
        if (!isNullOrUndefined(date)) {
          return formatDate(date || '', 'MMM YYYY');
        }
      })
    );
  }

  private selectEsgDate(): Observable<string> {
    return this.store.pipe(
      select(selectEsgDate),
      map(date => {
        if (!isNullOrUndefined(date)) {
          return formatDate(date || '', 'MMM YYYY');
        }
      })
    );
  }

  private selectYears(): Observable<number[]> {
    return this.store.pipe(
      select(selectEsgYears)
    );
  }

  private selectMonths(): Observable<Month[]> {
    return this.store.pipe(
      select(selectEsgMonths)
    );
  }

  public onChangeTab(event: number): void {
    this.selectedFund$.next('');
    this.selectedTabIndex$.next(event);
    this.sort$.next({ column: 'name', reverse: false });
    if (event === 2 || event === 4) {
      this.resetChart$.next(false);
      this.resetChart$.next(true);
      this.levelDrillDown$.next(0);
    } else {
      this.resetChart$.next(false);
    }
  }


  // public onChangeYear(event: number[]): void {
  //   if (event.length) {
  //     this.store.dispatch(new SetEsgYearFilterAction(event[0]));
  //     this.store.pipe(
  //       select(selectEsgMonths),
  //       take(1)
  //     ).subscribe(months => {
  //       this.selectedFund$.next('');
  //       this.resetDrillDownFilter();
  //       this.store.dispatch(new SetEsgMonthFilterAction(months[months.length - 1].value));
  //     });
  //   }
  // }

  public onChangeYear(event: number): void {
    if (event) {
      this.store.dispatch(new SetEsgYearFilterAction(event));
      this.store.pipe(
        select(selectEsgMonths),
        take(1)
      ).subscribe(months => {
        this.selectedFund$.next('');
        this.resetDrillDownFilter();
        this.store.dispatch(new SetEsgMonthFilterAction(months[months.length - 1].value));
      });
    }
  }

  public onChangeMonth(event: number): void {
    if (event) {
      this.selectedFund$.next('');
      this.resetDrillDownFilter();
      this.store.dispatch(new SetEsgMonthFilterAction(event));
    }
  }

  private resetDrillDownFilter() {
    this.levelDrillDown$.next(1);
    this.sdgLevelThreeType$.next('');
    this.resetChart$.next(false);
    this.resetChart$.next(true);
  }

  private selectEsgDiversityAndInclusionTable(): Observable<any> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgDiversityAndInclusion)),
    //   this.sort$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgDiversityAndInclusion)),
      this.sort$]
    ).pipe(
      map(([EsgDataDiversityAndInclusion, sort]) => {
        if (!isNullOrUndefined(EsgDataDiversityAndInclusion) && EsgDataDiversityAndInclusion.length > 0) {
          EsgDataDiversityAndInclusion = sort.reverse
            ? this.sort(EsgDataDiversityAndInclusion, sort).reverse()
            : this.sort(EsgDataDiversityAndInclusion, sort);
          return EsgDataDiversityAndInclusion;
        }
      }));
  }

  private selectEsgModernSlaveryTable(): Observable<any> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgModernSlavery)),
    //   this.sort$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgModernSlavery)),
      this.sort$]
    ).pipe(
      map(([esgModernSlavery, sort]) => {
        if (!isNullOrUndefined(esgModernSlavery) && esgModernSlavery.length > 0) {
          esgModernSlavery = esgModernSlavery.map(record =>
          ({
            ...record,
            companiesRedFlag: record.companiesRedFlag !== 'N/A'
              ? this.decimal.transform(record.companiesRedFlag.toString()) : record.companiesRedFlag
          }
          ));
          esgModernSlavery = sort.reverse
            ? this.sort(esgModernSlavery, sort).reverse()
            : this.sort(esgModernSlavery, sort);
          return esgModernSlavery;
        }
      }));
  }

  private selectEsgAnalyticsClimateTransitionCarbonWeightData(): Observable<Chart> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgAnalyticsClimateTransitionCarbonWeight))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgAnalyticsClimateTransitionCarbonWeight))]
    ).pipe(
      map(([esgAnalyticsClimateTransitionCarbonWeight]) => {
        if (!isNullOrUndefined(esgAnalyticsClimateTransitionCarbonWeight)
          && esgAnalyticsClimateTransitionCarbonWeight.length > 0) {
          const fundList = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.name),
            dgy = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.dgy),
            lgy = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.lgy),
            gyib = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.gyib),
            ib = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.ib),
            gnib = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.gnib),
            lgn = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.lgn),
            dgn = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.dgn),
            notAssessed = esgAnalyticsClimateTransitionCarbonWeight.map((record) => record.notAssessed);
          return new Chart({
            chart: {
              type: 'bar',
              width: 1100,
              style: {
                fontFamily: '"proxima_nova_regular", "Helvetica", "Arial", "sans-serif"',
              },
            },
            legend: {
              reversed: true,
              symbolRadius: 0
            },
            title: {
              text: 'Results by Weight (%)',
              style: {
                fontWeight: 'bold',
              }
            },
            xAxis: {
              min: 0,
              max: (fundList.length > 0) ? ((fundList.length >= 5) ? 4 : fundList.length - 1) : null,
              endOnTick: true,
              categories: fundList,
              scrollbar: {
                enabled: (fundList.length >= 4) ? true : false,
                margin: 25
              }
            },
            yAxis: {
              min: 0,
              tickInterval: 10,
              title: {
                text: ''
              },
              labels: {
                formatter: function () {
                  return this.value + '%';
                }
              },
              max: 100,
              opposite: true
            },
            tooltip: {
              enabled: true,
              formatter(): string {
                return `
                <span style="display: block;">${this.x}</span><br>
                <span style="color: ${this.color}">●</span>
                <span>${this.series.name}:</span>
                <span style="font-weight: bold">${this.y}</span>
              `;
              }
            },
            plotOptions: {
              column: {
                stacking: 'percent'
              },
            },
            series: [
              {
                type: 'column',
                name: 'Not Assessed', // not accessed
                color: `rgba(0, 0, 0, 1)`,
                data: notAssessed
              },
              {
                type: 'column',
                name: 'Dark Green', // dgn
                color: `rgba(0, 176, 80, 1)`,
                data: dgn
              },
              {
                type: 'column',
                name: 'Light Green', // lgn
                color: `rgba(146, 208, 80, 1)`,
                data: lgn
              },
              {
                type: 'column',
                name: 'Green/In-between', // gnib
                color: `rgba(204, 255, 102, 1)`,
                data: gnib
              },
              {
                type: 'column',
                name: 'In-between', // ib
                color: `rgba(255, 192, 0, 1)`,
                data: ib
              },
              {
                type: 'column',
                name: 'Grey/In-between', // gyib
                color: `rgba(191, 143, 0, 1)`,
                data: gyib
              },
              {
                type: 'column',
                name: 'Light Grey', // lgy
                color: `rgba(191, 191, 191, 1)`,
                data: lgy
              },
              {
                type: 'column',
                name: 'Dark Grey', // dgy
                color: `rgba(128, 128, 128, 1)`,
                data: dgy
              },
            ],
            credits: {
              enabled: false
            },
            exporting: {
              enabled: false
            },
            responsive: {
              rules: [
                {
                  condition: {
                    maxWidth: 1200,
                  },
                  chartOptions: {
                    xAxis: {
                      labels: {
                        formatter() {
                          return breakSentenceByWhitespaces(this.value.toString(), 2);
                        },
                      },
                    },
                  },
                },
                {
                  condition: {
                    minWidth: 1200,
                  },
                  chartOptions: {
                    xAxis: {
                      labels: {
                        formatter() {
                          return breakSentenceByWhitespaces(this.value.toString());
                        },
                      },
                    },
                  },
                },
              ],
            },
          });
        }
      }));
  }

  private selectEsgAnalyticsClimateTransitionDataCarbonIntensityData(): Observable<Chart> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgAnalyticsClimateTransitionDataCarbonIntensity))
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgAnalyticsClimateTransitionDataCarbonIntensity))]
    ).pipe(
      map(([esgAnalyticsClimateTransitionDataCarbonIntensity]) => {
        if (!isNullOrUndefined(esgAnalyticsClimateTransitionDataCarbonIntensity)
          && esgAnalyticsClimateTransitionDataCarbonIntensity.length > 0) {
          const fundList = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.name),
            dgy = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.dgy),
            lgy = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.lgy),
            gyib = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.gyib),
            ib = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.ib),
            gnib = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.gnib),
            lgn = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.lgn),
            dgn = esgAnalyticsClimateTransitionDataCarbonIntensity.map((record) => record.dgn),
            decimal = this.decimal,
            records = [
              {
                type: 'column',
                name: 'Dark Green', // dgn
                color: `rgba(0, 176, 80, 1)`,
                data: dgn
              },
              {
                type: 'column',
                name: 'Light Green', // lgn
                color: `rgba(146, 208, 80, 1)`,
                data: lgn
              },
              {
                type: 'column',
                name: 'Green/In-between', // gnib
                color: `rgba(204, 255, 102, 1)`,
                data: gnib
              },
              {
                type: 'column',
                name: 'In-between', // ib
                color: `rgba(255, 192, 0, 1)`,
                data: ib
              },
              {
                type: 'column',
                name: 'Grey/In-between', // gyib
                color: `rgba(191, 143, 0, 1)`,
                data: gyib
              },
              {
                type: 'column',
                name: 'Light Grey', // lgy
                color: `rgba(191, 191, 191, 1)`,
                data: lgy
              },
              {
                type: 'column',
                name: 'Dark Grey', // dgy
                color: `rgba(128, 128, 128, 1)`,
                data: dgy
              },
            ];
          let carbonIntensityData = [];
          records.forEach(rec => {
            carbonIntensityData = [...carbonIntensityData, ...rec.data];
          });

          return new Chart({
            chart: {
              type: 'column',
              width: 1100,
              style: {
                fontFamily: '"proxima_nova_regular", "Helvetica", "Arial", "sans-serif"',
              },
            },
            legend: {
              reversed: true,
              symbolRadius: 0
            },
            credits: {
              enabled: false
            },
            exporting: {
              enabled: false
            },
            title: {
              text: 'Results by Carbon Intensity (TCO2/$M Rev)',
              style: {
                fontWeight: 'bold',
              }
            },
            xAxis: {
              categories: fundList,
              min: 0,
              max: (fundList.length > 0) ? ((fundList.length >= 5) ? 4 : fundList.length - 1) : null, // TO DO
              scrollbar: {
                enabled: (fundList.length >= 4) ? true : false,
                margin: 25
              }
            },
            yAxis: {
              tickPositioner: function () {
                const min = Math.min(...carbonIntensityData.filter(rec => rec.toString() !== 'N/A')),
                  max = Math.max(...carbonIntensityData.filter(rec => rec.toString() !== 'N/A'));
                return getTickPositions(max, min);
              },
              title: {
                text: ''
              }
            },
            tooltip: {
              enabled: true,
              formatter(): string {
                return `
                <span style="display: block;">${this.x}</span><br>
                <span style="color: ${this.color}">●</span>
                <span>${this.series.name}:</span>
                <span style="font-weight: bold">${decimal.transform(this.y.toString())}</span>
              `;
              }
            },
            plotOptions: {
              column: {
                stacking: 'normal'
              },
            },
            // @ts-ignore
            series: records,
            responsive: {
              rules: [
                {
                  condition: {
                    maxWidth: 1200,
                  },
                  chartOptions: {
                    xAxis: {
                      labels: {
                        formatter() {
                          return breakSentenceByWhitespaces(this.value.toString(), 2);
                        },
                      },
                    },
                  },
                },
                {
                  condition: {
                    minWidth: 1200,
                  },
                  chartOptions: {
                    xAxis: {
                      labels: {
                        formatter() {
                          return breakSentenceByWhitespaces(this.value.toString());
                        },
                      },
                    },
                  },
                },
              ],
            },
          });
        }
      }));
  }

  private selectEsgProxyVotingTable(): Observable<any> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgProxyVoting)),
    //   this.sort$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgProxyVoting)),
      this.sort$]
    ).pipe(
      map(([esgProxyVoting, sort]) => {
        if (!isNullOrUndefined(esgProxyVoting) && esgProxyVoting.length > 0) {
          esgProxyVoting = esgProxyVoting.map(record =>
          ({
            ...record,
            meetingsVotedNumAus: record.meetingsVotedNumAus !== 'N/A'
              ? this.decimal.transform(record.meetingsVotedNumAus.toString()) : record.meetingsVotedNumAus,
            meetingsVotedNumGlobalExAus: record.meetingsVotedNumGlobalExAus !== 'N/A'
              ? this.decimal.transform(record.meetingsVotedNumGlobalExAus.toString()) : record.meetingsVotedNumGlobalExAus,
            supervotesNumGlobal: record.supervotesNumGlobal !== 'N/A'
              ? this.decimal.transform(record.supervotesNumGlobal.toString()) : record.supervotesNumGlobal
          }
          ));
          esgProxyVoting = sort.reverse
            ? this.sort(esgProxyVoting, sort).reverse()
            : this.sort(esgProxyVoting, sort);
          return esgProxyVoting;
        }
      }));
  }

  private selectEsgRatingTable(): Observable<any> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgRatings)),
    //   this.sort$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgRatings)),
      this.sort$]
    ).pipe(
      map(([esgRating, sort]) => {
        if (!isNullOrUndefined(esgRating) && esgRating.length > 0) {
          esgRating = sort.reverse
            ? this.sort(esgRating, sort).reverse()
            : this.sort(esgRating, sort);
          return esgRating;
        }
      }));
  }




  private selectPagination(): Observable<PaginationInfo> {
    return this.store.pipe(
      select(selectEsgData),
      filter(records => !!records),
      map(records => ({
        page: 1,
        itemsByPage: records.length,
        total: records.length
      }))
    );
  }

  private sort(data, sort: SortInfo): any {
    let column;
    switch (sort.column) {
      case 'name':
        return sortBy(data, fund => +fund['name']);
      case 'diBoardDiversityFund':
      case 'diBoardDiversityBenchMark':
        column = sort.column as keyof EsgDiversityAndInclusionTable;
        return sortBy(data, fund => +fund[column]);
      case 'companiesRedFlag':
      case 'porttfolioPercentRedFlag':
        column = sort.column as keyof EsgModernSlaveryTable;
        return sortBy(data, fund => +fund[column]);
      case 'secondLastYearCarbonFootPrint':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.carbonFootprint)) {
            return +fund.carbonFootprint.footprintFund.secondLastYear;
          }
        });
      case 'lastYearCarbonFootPrint':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.carbonFootprint)) {
            return +fund.carbonFootprint.footprintFund.lastYear;
          }
        });
      case 'currentYearCarbonFootPrint':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.carbonFootprint)) {
            return +fund.carbonFootprint.footprintFund.currentYear;
          }
        });
      case 'currentYearUniverseEsgRating':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.esgRating)) {
            return +fund.esgRating.ratingUniverse.currentYear;
          }
        });
      case 'lastYearUniverseEsgRating':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.esgRating)) {
            return +fund.esgRating.ratingUniverse.lastYear;
          }
        });
      case 'secondLastYearUniverseEsgRating':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.esgRating)) {
            return +fund.esgRating.ratingUniverse.secondLastYear;
          }
        });
      case 'currentYearEsgRating':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.esgRating)) {
            return +fund.esgRating.ratingFund.currentYear;
          }
        });
      case 'lastYearEsgRating':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.esgRating)) {
            return +fund.esgRating.ratingFund.lastYear;
          }
        });
      case 'secondlastYearEsgRating':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.esgRating)) {
            return +fund.esgRating.ratingFund.secondLastYear;
          }
        });
      case 'overall':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level1)) {
            return +fund.level1.overAllFund;
          }
        });
      case 'social':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level2)) {
            return +fund.level2.social.socialFund;
          }
        });
      case 'environmental':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level2)) {
            return +fund.level2.environmental.environmentalFund;
          }
        });
      case 'alleviatingPoverty':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.social.alleviatingPovertyFund;
          }
        });
      case 'attainingGenderEquality':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.social.attainingGenderEqualityFund;
          }
        });

      case 'combatingHunger':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.social.combatingHungerFund;
          }
        });
      case 'deliveringEducation':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.social.deliveringEducationFund;
          }
        });
      case 'ensuringHealth':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.social.ensuringHealthFund;
          }
        });
      case 'providingBasicServices':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.social.providingBasicServicesFund;
          }
        });
      case 'safeguardingPeace':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.social.safeguardingPeaceFund;
          }
        });
      case 'achievingSustainableAgricultureAndForests':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.achievingSustainableAgricultureAndForestsFund;
          }
        });
      case 'conservingWater':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.conservingWaterFund;
          }
        });
      case 'contributingtoSustainableEnergyUse':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.contributingtoSustainableEnergyUseFund;
          }
        });
      case 'mitigatingClimateChange':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.mitigatingClimateChangeFund;
          }
        });
      case 'optimisingMaterialUse':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.optimisingMaterialUseFund;
          }
        });
      case 'preservingMarineEcosystems':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.preservingMarineEcosystemsFund;
          }
        });
      case 'preservingTerrestrialEcosystems':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.preservingTerrestrialEcosystemsFund;
          }
        });
      case 'promotingSustainableBuildingspromotingSustainableBuildings':
        return sortBy(data, fund => {
          if (!isNullOrUndefined(fund.level3)) {
            return +fund.level3.environmental.promotingSustainableBuildingsFund;
          }
        });
      default:
        return sortBy(data, sort.column);
    }
  }


  private subscribeLoadEsg(): Subscription {
    return combineLatest(
      [this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectMainFilterSelectedAccount))]
    ).pipe(
      distinctUntilChanged(isEqual)
    ).subscribe(([date, accountId]) => {
      if (!!accountId && !!date) {
        this.store.dispatch(new LoadEsgAction({ account: accountId._id || '', date, country: this.country }));
        const currentYear = formatDate(date || '', 'MMM YYYY'),
          lastYear = formatDate(moment.utc(date).subtract(1, 'year').format('YYYY-MM-DD'), 'MMM YYYY'),
          secondLastYear = formatDate(moment.utc(date).subtract(2, 'year').format('YYYY-MM-DD'), 'MMM YYYY');

        // this.headerEsgRating = [
        //   {
        //     name: 'Name',
        //     column: 'name'
        //   },
        //   {
        //     name: 'Allocation',
        //     column: 'allocation'
        //   },
        //   {
        //     name: secondLastYear,
        //     column: 'secondLastYearEsgRating',
        //     textAlign: 'right'
        //   },
        //   {
        //     name: secondLastYear,
        //     column: 'secondLastYearUniverseEsgRating',
        //     textAlign: 'right'
        //   },
        //   {
        //     name: lastYear,
        //     column: 'lastYearUniverseEsgRating',
        //     textAlign: 'right'
        //   },
        //   {
        //     name: currentYear,
        //     column: 'currentYearUniverseEsgRating',
        //     textAlign: 'right'
        //   }
        // ];


        this.headerEsgRating = [
          {
            name: 'Name',
            column: 'name',
            displayLabel: 'Name',
            fieldKey: 'name'
          },
          {
            name: 'Allocation',
            column: 'allocation',
            displayLabel: 'Allocation',
            fieldKey: 'allocation',

          },
          {
            name: secondLastYear,
            column: 'secondLastYearEsgRating',
            align: TableColumnAlignment.right,
            displayLabel: secondLastYear,
            fieldKey: 'secondLastYearEsgRating',
          },
          {
            name: lastYear,
            column: 'lastYearEsgRating',
            align: TableColumnAlignment.right,
            displayLabel: lastYear,
            fieldKey: 'lastYearEsgRating',

          },
          {
            name: currentYear,
            column: 'currentYearEsgRating',
            align: TableColumnAlignment.right,
            displayLabel: currentYear,
            fieldKey: 'currentYearEsgRating',

          },
          {
            name: secondLastYear,
            column: 'secondLastYearUniverseEsgRating',
            align: TableColumnAlignment.right,
            displayLabel: secondLastYear,
            fieldKey: 'secondLastYearUniverseEsgRating',

          },
          {
            name: lastYear,
            column: 'lastYearUniverseEsgRating',
            align: TableColumnAlignment.right,
            displayLabel: lastYear,
            fieldKey: 'lastYearUniverseEsgRating',

          },
          {
            name: currentYear,
            column: 'currentYearUniverseEsgRating',
            align: TableColumnAlignment.right,
            displayLabel: currentYear,
            fieldKey: 'currentYearUniverseEsgRating',

          }
        ];
        // this.headerEsgCarbonFootPrint = [
        //   {
        //     name: 'Name',
        //     column: 'name'
        //   }, {
        //     name: secondLastYear,
        //     column: 'secondLastYearCarbonFootPrint',
        //     textAlign: 'right'
        //   },
        //   {
        //     name: lastYear,
        //     column: 'lastYearCarbonFootPrint',
        //     textAlign: 'right'
        //   },

        // ];


        this.headerEsgCarbonFootPrint = [
          {
            name: 'Name',
            column: 'name',
            displayLabel: 'Name',
            fieldKey: 'name'

          }, {
            name: secondLastYear,
            column: 'secondLastYearCarbonFootPrint',
            align: TableColumnAlignment.right,
            displayLabel: secondLastYear,
            fieldKey: 'secondLastYearCarbonFootPrint',

          },
          {
            name: lastYear,
            column: 'lastYearCarbonFootPrint',
            align: TableColumnAlignment.right,
            displayLabel: lastYear,
            fieldKey: 'lastYearCarbonFootPrint',

          },
          {
            name: currentYear,
            column: 'currentYearCarbonFootPrint',
            align: TableColumnAlignment.right,
            displayLabel: currentYear,
            fieldKey: 'currentYearCarbonFootPrint',
          }
        ];
      } else {
        this.store.dispatch(new ResetEsgDataAction());
      }
    });
  }

  private subscribeConsultantLoad(): Subscription {
    return this.user$.subscribe(user => {
      if (user) {
        this.store.pipe(select(selectMainFilterSelectedClient)).subscribe(client => {
          if (!isNullOrUndefined(client)) {
            this.store.dispatch(new LoadClientConsultantAction(client._id));
          }
        });
      }
    });
  }

  public onSort(sort: SortInfo): void {
    this.sort$.next(sort);
  }

  private selectEsgCarbonFootPrintTable(): Observable<any> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgCarbonFootPrint)),
    //   this.sort$,
    //   this.selectedFund$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgCarbonFootPrint)),
      this.sort$,
      this.selectedFund$]
    ).pipe(
      map(([esgCarbonFootPrint, sort, selectedFund]) => {
        if (!isNullOrUndefined(esgCarbonFootPrint) && esgCarbonFootPrint.length > 0) {
          esgCarbonFootPrint = sort.reverse
            ? this.sort(esgCarbonFootPrint, sort).reverse()
            : this.sort(esgCarbonFootPrint, sort);
          return this.generateTableEsgCarbonFootPrint(esgCarbonFootPrint, selectedFund);
        }
      }),
      distinctUntilChanged(isEqual)

    );
  }

  private generateTableEsgCarbonFootPrint(esgCarbonFootPrint, selectedFund) {
    const highlighted = [],
      data = [];

    esgCarbonFootPrint.forEach((record) => {
      if (selectedFund === record.name) {
        highlighted.push({
          name: record.name,
          selected: selectedFund === record.name,
          secondLastYear: record.carbonFootprint.footprintFund.secondLastYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintFund.secondLastYear.toString())
            : record.carbonFootprint.footprintFund.secondLastYear,
          lastYear: record.carbonFootprint.footprintFund.lastYear !== 'N/A' ?
            this.decimal.transform(record.carbonFootprint.footprintFund.lastYear.toString())
            : record.carbonFootprint.footprintFund.lastYear,
          currentYear: record.carbonFootprint.footprintFund.currentYear !== 'N/A' ?
            this.decimal.transform(record.carbonFootprint.footprintFund.currentYear.toString())
            : record.carbonFootprint.footprintFund.currentYear,
        });

        highlighted.push({
          parent: record.name,
          name: 'Benchmark',
          selected: selectedFund === record.name,
          secondLastYear: record.carbonFootprint.footprintBenchmark.secondLastYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintBenchmark.secondLastYear.toString())
            : record.carbonFootprint.footprintBenchmark.secondLastYear,
          lastYear: record.carbonFootprint.footprintBenchmark.lastYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintBenchmark.lastYear.toString())
            : record.carbonFootprint.footprintBenchmark.lastYear,
          currentYear: record.carbonFootprint.footprintBenchmark.currentYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintBenchmark.currentYear.toString())
            : record.carbonFootprint.footprintBenchmark.currentYear,
        });
      } else {
        data.push({
          name: record.name,
          selected: selectedFund === record.name,
          secondLastYear: record.carbonFootprint.footprintFund.secondLastYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintFund.secondLastYear.toString())
            : record.carbonFootprint.footprintFund.secondLastYear,
          lastYear: record.carbonFootprint.footprintFund.lastYear !== 'N/A' ?
            this.decimal.transform(record.carbonFootprint.footprintFund.lastYear.toString())
            : record.carbonFootprint.footprintFund.lastYear,
          currentYear: record.carbonFootprint.footprintFund.currentYear !== 'N/A' ?
            this.decimal.transform(record.carbonFootprint.footprintFund.currentYear.toString())
            : record.carbonFootprint.footprintFund.currentYear,
        });

        data.push({
          parent: record.name,
          name: 'Benchmark',
          selected: selectedFund === record.name,
          secondLastYear: record.carbonFootprint.footprintBenchmark.secondLastYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintBenchmark.secondLastYear.toString())
            : record.carbonFootprint.footprintBenchmark.secondLastYear,
          lastYear: record.carbonFootprint.footprintBenchmark.lastYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintBenchmark.lastYear.toString())
            : record.carbonFootprint.footprintBenchmark.lastYear,
          currentYear: record.carbonFootprint.footprintBenchmark.currentYear !== 'N/A'
            ? this.decimal.transform(record.carbonFootprint.footprintBenchmark.currentYear.toString())
            : record.carbonFootprint.footprintBenchmark.currentYear,
        });
      }
    });

    const table = [...highlighted, ...data];
    return table;
  }

  private selectCarbonFootPrintChart(): Observable<Chart> {
    return combineLatest([
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgCarbonFootPrint)),
      this.resetChart$]
    ).pipe(
      filter(([date, esgCarbonFootPrint]) => !!esgCarbonFootPrint),
      distinctUntilChanged(isEqual),
      map(([date, esgCarbonFootPrint]) => {
        const pipe = this.decimal;
        if (!isNullOrUndefined(esgCarbonFootPrint)
          && esgCarbonFootPrint.length > 0) {
          const currentYear = formatDate(date || '', 'MMM YYYY'),
            lastYear = formatDate(moment.utc(date).subtract(1, 'year').format('YYYY-MM-DD'), 'MMM YYYY'),
            secondLastYear = formatDate(moment.utc(date).subtract(2, 'year').format('YYYY-MM-DD'), 'MMM YYYY'),

            series = [],
            drilldownData = [],

            firstLevelFundDetail = {
              name: 'Fund',
              color: '#F48132',
              data: [],
              range: {
                min: 0,
                max: 0
              }
            },
            firstLevelBenchmarkDetail = {
              name: 'Benchmark',
              color: '#BBEEF9',
              data: []
            };
          esgCarbonFootPrint.forEach((record) => {

            firstLevelFundDetail.data.push({
              name: record.name,
              y: parseFloat(record.carbonFootprint.footprintFund.currentYear),
              drilldown: record.name
            });

            firstLevelBenchmarkDetail.data.push({
              name: record.name,
              y: parseFloat(record.carbonFootprint.footprintBenchmark.currentYear),
              drilldown: record.name + '.bench'
            });


            const secondLevelFundDetail = {
              name: `${record.name}.Fund`,
              id: record.name,
              data: [],
              range: {
                min: 0,
                max: 0
              }
            },


              secondLevelBenchmarkDetail = {
                name: `${record.name}.Benchmark`,
                id: record.name + '.bench',
                data: [],
                range: {
                  min: 0,
                  max: 0
                }
              };

            secondLevelFundDetail.data.push({
              name: secondLastYear,
              tooltip: 'Fund',
              y: parseFloat(record.carbonFootprint.footprintFund.secondLastYear),
            });

            secondLevelBenchmarkDetail.data.push({
              name: secondLastYear,
              tooltip: 'Benchmark',
              y: parseFloat(record.carbonFootprint.footprintBenchmark.secondLastYear),
            });

            secondLevelFundDetail.data.push({
              name: lastYear,
              tooltip: 'Fund',
              y: parseFloat(record.carbonFootprint.footprintFund.lastYear),
            });

            secondLevelBenchmarkDetail.data.push({
              name: lastYear,
              tooltip: 'Benchmark',
              y: parseFloat(record.carbonFootprint.footprintBenchmark.lastYear),
            });

            secondLevelFundDetail.data.push({
              name: currentYear,
              tooltip: 'Fund',
              y: parseFloat(record.carbonFootprint.footprintFund.currentYear),
            });

            secondLevelBenchmarkDetail.data.push({
              name: currentYear,
              tooltip: 'Benchmark',
              y: parseFloat(record.carbonFootprint.footprintBenchmark.currentYear),
            });

            const maxMin = getMinMaxValues(secondLevelFundDetail.data, secondLevelBenchmarkDetail.data, 'y');
            secondLevelFundDetail.range.max = maxMin.max;
            secondLevelFundDetail.range.min = maxMin.min;
            secondLevelBenchmarkDetail.range.max = maxMin.max;
            secondLevelBenchmarkDetail.range.min = maxMin.min;
            drilldownData.push(secondLevelFundDetail);
            drilldownData.push(secondLevelBenchmarkDetail);
          });

          const maxMin = getMinMaxValues(firstLevelFundDetail.data, firstLevelBenchmarkDetail.data, 'y');
          firstLevelFundDetail.range.max = maxMin.max;
          firstLevelFundDetail.range.min = maxMin.min;

          series.push(firstLevelFundDetail);
          series.push(firstLevelBenchmarkDetail);

          const filterCarbonFootPrintFund = this.selectedFund$;

          return new Chart({
            lang: {
              drillUpText: '◁ Back'
            },
            chart: {
              type: 'column',
              style: {
                fontFamily: '"proxima_nova_regular", "Helvetica", "Arial", "sans-serif"',
              },
              events: {
                drilldown(event): void {
                  setTimeout(() => {
                    const options = event.seriesOptions as SeriesBarOptions,
                      max = options.data.length - 1 >= 6,
                      selectdFund = (options.name.includes('.'))
                        ? options.name.split('.')[0]
                        : options.name;
                    filterCarbonFootPrintFund.next(selectdFund || '');
                    this.update({
                      xAxis: {
                        max: max ? 6 : options.data.length - 1
                      },
                      yAxis: {
                        tickPositioner: function () {
                          // @ts-ignore
                          const maxValue = options.range.max,
                            // @ts-ignore
                            minValue = options.range.min;
                          return getTickPositions(maxValue, minValue);
                        },
                      }
                    });
                  });
                },
                drillup(event): void {
                  const options = event.seriesOptions as SeriesBarOptions;
                  setTimeout(() => {
                    filterCarbonFootPrintFund.next('');
                    this.update({
                      xAxis: {
                        max: (esgCarbonFootPrint.length > 0)
                          ? ((esgCarbonFootPrint.length >= 5) ? 4 : esgCarbonFootPrint.length - 1)
                          : null, // TO DO
                      },
                      yAxis: {
                        tickPositioner: function () {
                          // @ts-ignore
                          const max = options.range.max,
                            // @ts-ignore
                            min = options.range.min;
                          return getTickPositions(max, min);
                        },
                      }
                    });
                  });
                }
              }
            },
            credits: {
              enabled: false
            },
            title: {
              style: {
                display: 'none'
              }
            },
            exporting: {
              enabled: false
            },
            plotOptions: {
              column: {
                cropThreshold: 250,
                clip: false,
                dataLabels: {
                  enabled: true,
                  formatter() {
                    // @ts-ignore
                    return Number.isInteger(this.y)
                      // @ts-ignore
                      ? `${pipe.transform(this.y.toFixed(1).toString())}`
                      // @ts-ignore
                      : `${pipe.transform(this.y.toString())}`;

                  }
                }
              },
              series: {
                pointWidth: 30,
                dataLabels: {
                  enabled: true,
                  crop: false,
                  style: {
                    color: 'contrast',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    textOutline: '1px contrast',
                  }
                }
              }
            } as PlotOptions,
            tooltip: {
              enabled: true,
              formatter(): string {
                const { tooltip, name } = this.point['tooltip'] !== undefined
                  ? {
                    tooltip: this.series.name.includes('.')
                      ? this.series.name.split('.')[0]
                      : this.series.name, name: this.point['tooltip']
                  }
                  : { tooltip: this.point.name, name: this.series.name };
                return `
                  <span style="display: block; font-size: 10px">${tooltip}</span><br>
                  <span style="color: ${this.color}">●</span>
                  <span>${name}:</span>
              <span style="font-weight: bold">${pipe.transform(this.y.toString())}</span>
                `;
              }
            },
            legend: {
              enabled: true,
              symbolRadius: 0

            },
            yAxis: {
              tickPositioner: function () {
                const max = series[0].range.max,
                  min = series[0].range.min;
                return getTickPositions(max, min);
              },
              plotLines: [{ color: '#003399', width: 1.2, value: 0, }],
              title: {
                text: ''
              }
            },
            xAxis: {
              type: 'category',
              gridLineWidth: 1,
              labels: {
                rotation: 0,
                style: {
                  textOverflow: 'none',
                  min: 0,
                  lineWidth: 4,

                },
                formatter() {
                  return typeof this.value !== 'number' ? this.value : '';
                }
              },
              max: (esgCarbonFootPrint.length > 0) ? ((esgCarbonFootPrint.length >= 5) ? 4 : esgCarbonFootPrint.length - 1) : null, // TO DO
              endOnTick: true,
              scrollbar: {
                enabled: true,
                showFull: false,
                margin: 25
              }
            },
            series,
            drilldown: {
              activeAxisLabelStyle: {
                cursor: 'pointer',
                color: '#003399',
                fontWeight: 'bold',
                textDecoration: 'none',
              },
              activeDataLabelStyle: {
                cursor: 'pointer',
                color: '#003399',
                fontWeight: 'bold',
                textDecoration: 'none',
              },
              allowPointDrilldown: false,
              series: drilldownData
            } as DrilldownOptions,
            responsive: {
              rules: [
                {
                  condition: {
                    maxWidth: 1200,
                  },
                  chartOptions: {
                    xAxis: {
                      labels: {
                        formatter() {
                          return breakSentenceByWhitespaces(this.value.toString(), 2);
                        },
                      },
                    },
                  },
                }
              ],
            },
          });
        }
      })
    );
  }

  private selectEsgUNDevGoalsChart(): Observable<Chart> {
    return combineLatest([
      this.store.pipe(select(selectEsgSdgData)),
      this.resetChart$]
    ).pipe(
      filter(([sdgData]) => !!sdgData),
      distinctUntilChanged(isEqual),
      map(([sdgData]) => {
        if (!isNullOrUndefined(sdgData)
          && sdgData.length > 0) {
          const series = [],
            DrilldownData = [],

            firstLevelFundDetail = {
              name: 'Fund',
              color: '#F48132',
              data: [],
              range: {
                min: 0,
                max: 0
              }
            },
            firstLevelBenchmarkDetail = {
              name: 'Benchmark',
              color: '#BBEEF9',
              data: [],
              range: {
                min: 0,
                max: 0
              }
            };
          sdgData.forEach((record) => {
            firstLevelFundDetail.data.push({
              name: record.name,
              y: parseFloat(record.level1.overAllFund),
              drilldown: record.name
            });

            firstLevelBenchmarkDetail.data.push({
              name: record.name,
              y: parseFloat(record.level1.overAllBenchmark),
              drilldown: record.name + '.bench'
            });

            const secondLevelFundDetail = {
              name: `Fund`,
              id: record.name,
              fund: record.name,
              xAxisDisplay: `${record.name}`,
              level: 2,
              data: [],
              range: {
                min: 0,
                max: 0
              }
            },

              secondLevelBenchmarkDetail = {
                name: `Benchmark`,
                id: record.name + '.bench',
                fund: record.name,
                xAxisDisplay: `${record.name}`,
                level: 2,
                data: [],
                range: {
                  min: 0,
                  max: 0
                }
              };



            secondLevelFundDetail.data.push({
              name: `${EsgSdgLevelTwo.social}`,
              tooltip: `${record.name}.${EsgSdgLevelTwo.social}.Fund`,
              y: parseFloat(record.level2.social.socialFund),
              drilldown: record.name + '.social'
            });

            secondLevelBenchmarkDetail.data.push({
              name: `${EsgSdgLevelTwo.social}`,
              tooltip: `${record.name}.${EsgSdgLevelTwo.social}.Benchmark`,
              y: parseFloat(record.level2.social.socialBenchmark),
              drilldown: record.name + '.social.bench'
            });

            secondLevelFundDetail.data.push({
              name: `${EsgSdgLevelTwo.environmental}`,
              tooltip: `${record.name}.${EsgSdgLevelTwo.environmental}.Fund`,
              y: parseFloat(record.level2.environmental.environmentalFund),
              drilldown: record.name + '.environmental'
            });

            secondLevelBenchmarkDetail.data.push({
              name: `${EsgSdgLevelTwo.environmental}`,
              tooltip: `${record.name}.${EsgSdgLevelTwo.environmental}.Benchmark`,
              y: parseFloat(record.level2.environmental.environmentalBenchmark),
              drilldown: record.name + '.environmental.bench'
            });
            let maxMin = getMinMaxValues(secondLevelFundDetail.data, secondLevelBenchmarkDetail.data, 'y');
            secondLevelFundDetail.range.max = maxMin.max;
            secondLevelFundDetail.range.min = maxMin.min;
            secondLevelBenchmarkDetail.range.max = maxMin.max;
            secondLevelBenchmarkDetail.range.min = maxMin.min;
            DrilldownData.push(secondLevelFundDetail);
            DrilldownData.push(secondLevelBenchmarkDetail);

            const thirdLevelFundDetailSocial = {
              name: `Fund`,
              id: record.name + '.social',
              levelThreeType: 'social',
              fund: record.name,
              xAxisDisplay: `${record.name} | ${EsgSdgLevelTwo.social}`,
              level: 3,
              data: [],
              range: {
                min: 0,
                max: 0
              }
            },

              thirdLevelBenchmarkDetailSocial = {
                name: `Benchmark`,
                id: record.name + '.social.bench',
                levelThreeType: 'social',
                fund: record.name,
                xAxisDisplay: `${record.name} | ${EsgSdgLevelTwo.social}`,
                level: 3,
                data: [],
                range: {
                  min: 0,
                  max: 0
                }
              },

              thirdLevelFundDetailEnvironmental = {
                name: `Fund`,
                id: record.name + '.environmental',
                levelThreeType: 'environmental',
                fund: record.name,
                xAxisDisplay: `${record.name} | ${EsgSdgLevelTwo.environmental}`,
                level: 3,
                data: [],
                range: {
                  min: 0,
                  max: 0
                }
              },

              thirdLevelBenchmarkDetailEnvironmental = {
                name: `Benchmark`,
                id: record.name + '.environmental.bench',
                levelThreeType: 'environmental',
                fund: record.name,
                xAxisDisplay: `${record.name} | ${EsgSdgLevelTwo.environmental}`,
                level: 3,
                data: [],
                range: {
                  min: 0,
                  max: 0
                }
              };
            thirdLevelFundDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.alleviatingPoverty,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.alleviatingPoverty}.Fund`,
              y: parseFloat(record.level3.social.alleviatingPovertyFund)
            });

            thirdLevelBenchmarkDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.alleviatingPoverty,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.alleviatingPoverty}.Benchmark`,
              y: parseFloat(record.level3.social.alleviatingPovertyBenchmark),
            });

            thirdLevelFundDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.attainingGenderEquality,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.attainingGenderEquality}.Fund`,
              y: parseFloat(record.level3.social.attainingGenderEqualityFund)
            });

            thirdLevelBenchmarkDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.attainingGenderEquality,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.attainingGenderEquality}.Benchmark`,
              y: parseFloat(record.level3.social.attainingGenderEqualityFund),
            });
            thirdLevelFundDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.combatingHunger,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.combatingHunger}.Fund`,
              y: parseFloat(record.level3.social.combatingHungerFund)
            });

            thirdLevelBenchmarkDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.combatingHunger,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.combatingHunger}.Benchmark`,
              y: parseFloat(record.level3.social.combatingHungerBenchmark),
            });
            thirdLevelFundDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.deliveringEducation,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.deliveringEducation}.Fund`,
              y: parseFloat(record.level3.social.deliveringEducationFund)
            });

            thirdLevelBenchmarkDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.deliveringEducation,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.deliveringEducation}.Benchmark`,
              y: parseFloat(record.level3.social.deliveringEducationBenchmark),
            });
            thirdLevelFundDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.ensuringHealth,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.ensuringHealth}.Fund`,
              y: parseFloat(record.level3.social.ensuringHealthFund)
            });

            thirdLevelBenchmarkDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.ensuringHealth,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.ensuringHealth}.Benchmark`,
              y: parseFloat(record.level3.social.ensuringHealthBenchmark),
            });
            thirdLevelFundDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.providingBasicServices,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.providingBasicServices}.Fund`,
              y: parseFloat(record.level3.social.providingBasicServicesFund)
            });

            thirdLevelBenchmarkDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.providingBasicServices,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.providingBasicServices}.Benchmark`,
              y: parseFloat(record.level3.social.providingBasicServicesBenchmark),
            });
            thirdLevelFundDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.safeguardingPeace,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.safeguardingPeace}.Fund`,
              y: parseFloat(record.level3.social.safeguardingPeaceFund)
            });

            thirdLevelBenchmarkDetailSocial.data.push({
              name: EsgSdgLevelThreeSocial.safeguardingPeace,
              tooltip: `${record.name}.${EsgSdgLevelThreeSocial.safeguardingPeace}.Benchmark`,
              y: parseFloat(record.level3.social.safeguardingPeaceBenchmark),
            });

            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.achievingSustainableAgricultureAndForests,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.achievingSustainableAgricultureAndForests}.Fund`,
              y: parseFloat(record.level3.environmental.achievingSustainableAgricultureAndForestsFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.achievingSustainableAgricultureAndForests,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.achievingSustainableAgricultureAndForests}.Benchmark`,
              y: parseFloat(record.level3.environmental.achievingSustainableAgricultureAndForestsBenchmark),
            });

            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.conservingWater,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.conservingWater}.Fund`,
              y: parseFloat(record.level3.environmental.conservingWaterFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.conservingWater,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.conservingWater}.Benchmark`,
              y: parseFloat(record.level3.environmental.conservingWaterBenchmark),
            });
            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.contributingtoSustainableEnergyUse,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.contributingtoSustainableEnergyUse}.Fund`,
              y: parseFloat(record.level3.environmental.contributingtoSustainableEnergyUseFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.contributingtoSustainableEnergyUse,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.contributingtoSustainableEnergyUse}.Benchmark`,
              y: parseFloat(record.level3.environmental.contributingToSustainableEnergyUseBenchmark),
            });
            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.mitigatingClimateChange,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.mitigatingClimateChange}.Fund`,
              y: parseFloat(record.level3.environmental.mitigatingClimateChangeFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.mitigatingClimateChange,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.mitigatingClimateChange}.Benchmark`,
              y: parseFloat(record.level3.environmental.mitigatingClimateChangeBenchmark),
            });
            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.optimisingMaterialUse,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.optimisingMaterialUse}.Fund`,
              y: parseFloat(record.level3.environmental.optimisingMaterialUseFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.optimisingMaterialUse,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.optimisingMaterialUse}.Benchmark`,
              y: parseFloat(record.level3.environmental.optimisingMaterialUseBenchmark),
            });
            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.preservingMarineEcosystems,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.preservingMarineEcosystems}.Fund`,
              y: parseFloat(record.level3.environmental.preservingMarineEcosystemsFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.preservingMarineEcosystems,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.preservingMarineEcosystems}.Benchmark`,
              y: parseFloat(record.level3.environmental.preservingMarineEcosystemsBenchmark),
            });
            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.preservingTerrestrialEcosystems,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.preservingTerrestrialEcosystems}.Fund`,
              y: parseFloat(record.level3.environmental.preservingTerrestrialEcosystemsFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.preservingTerrestrialEcosystems,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.preservingTerrestrialEcosystems}.Benchmark`,
              y: parseFloat(record.level3.environmental.preservingTerrestrialEcosystemsBenchmark),
            });
            thirdLevelFundDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.promotingSustainableBuildings,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.promotingSustainableBuildings}.Fund`,
              y: parseFloat(record.level3.environmental.promotingSustainableBuildingsFund)
            });

            thirdLevelBenchmarkDetailEnvironmental.data.push({
              name: EsgSdgLevelThreeEnvironmental.promotingSustainableBuildings,
              tooltip: `${record.name}.${EsgSdgLevelThreeEnvironmental.promotingSustainableBuildings}.Benchmark`,
              y: parseFloat(record.level3.environmental.promotingSustainableBuildingsBenchmark),
            });
            maxMin = getMinMaxValues(thirdLevelFundDetailSocial.data, thirdLevelBenchmarkDetailSocial.data, 'y');
            thirdLevelFundDetailSocial.range.max = maxMin.max;
            thirdLevelFundDetailSocial.range.min = maxMin.min;
            thirdLevelBenchmarkDetailSocial.range.max = maxMin.max;
            thirdLevelBenchmarkDetailSocial.range.min = maxMin.min;
            DrilldownData.push(thirdLevelFundDetailSocial);
            DrilldownData.push(thirdLevelBenchmarkDetailSocial);
            maxMin = getMinMaxValues(thirdLevelFundDetailEnvironmental.data, thirdLevelBenchmarkDetailEnvironmental.data, 'y');
            thirdLevelFundDetailEnvironmental.range.max = maxMin.max;
            thirdLevelFundDetailEnvironmental.range.min = maxMin.min;
            thirdLevelBenchmarkDetailEnvironmental.range.max = maxMin.max;
            thirdLevelBenchmarkDetailEnvironmental.range.min = maxMin.min;
            DrilldownData.push(thirdLevelFundDetailEnvironmental);
            DrilldownData.push(thirdLevelBenchmarkDetailEnvironmental);
          });
          const maxMin = getMinMaxValues(firstLevelFundDetail.data, firstLevelBenchmarkDetail.data, 'y');
          firstLevelFundDetail.range.max = maxMin.max;
          firstLevelFundDetail.range.min = maxMin.min;
          series.push(firstLevelFundDetail);
          series.push(firstLevelBenchmarkDetail);
          const selectedFund = this.selectedFund$,
            levelDrillDown = this.levelDrillDown$,
            sdgLevelThreeType = this.sdgLevelThreeType$,
            sort = this.sort$;

          return new Chart({
            lang: {
              drillUpText: '◁ Back'
            },
            chart: {
              type: 'column',
              style: {
                fontFamily: '"proxima_nova_regular", "Helvetica", "Arial", "sans-serif"',
              },
              events: {
                drilldown(event): void {
                  setTimeout(() => {
                    const options = event.seriesOptions as SeriesBarOptions,
                      max = options.data.length - 1 >= 6,
                      // @ts-ignore
                      selectdFund = options.fund;
                    // @ts-ignore
                    levelDrillDown.next(options.level || 1);
                    selectedFund.next(selectdFund || '');
                    sort.next({ column: 'name', reverse: false });
                    // @ts-ignore
                    if (!isNullOrUndefined(options.levelThreeType)) {
                      // @ts-ignore
                      sdgLevelThreeType.next(options.levelThreeType);
                    }

                    this.update({
                      xAxis: {
                        title: {
                          // @ts-ignore
                          text: options.xAxisDisplay || 'Overall'
                        },
                        max: max ? 6 : options.data.length - 1
                      },
                      yAxis: {
                        tickPositioner: function () {
                          // @ts-ignore
                          const max = options.range.max,
                            // @ts-ignore
                            min = options.range.min;
                          return getTickPositions(max, min);
                        },
                      }
                    });
                  });
                },
                drillup(event): void {
                  setTimeout(() => {
                    const options = event.seriesOptions as SeriesBarOptions,
                      // @ts-ignore
                      selectdFund = options.fund;
                    // @ts-ignore
                    levelDrillDown.next(options.level || 1);
                    selectedFund.next(selectdFund || '');
                    sort.next({ column: 'name', reverse: false });
                    // @ts-ignore
                    if (!isNullOrUndefined(options.levelThreeType)) {
                      // @ts-ignore
                      sdgLevelThreeType.next(options.levelThreeType);
                    }
                    this.update({
                      xAxis: {
                        title: {
                          // @ts-ignore
                          text: options.xAxisDisplay || 'Overall'
                        },
                        max: null
                      },
                      yAxis: {
                        tickPositioner: function () {
                          // @ts-ignore
                          const max = options.range.max,
                            // @ts-ignore
                            min = options.range.min;
                          return getTickPositions(max, min);
                        },
                      }
                    });
                  });
                }
              }
            },
            credits: {
              enabled: false
            },
            title: {
              style: {
                display: 'none'
              }
            },
            exporting: {
              enabled: false
            },
            plotOptions: {
              column: {
                cropThreshold: 250,
                clip: false,
                dataLabels: {
                  enabled: true,
                  formatter() {
                    // @ts-ignore
                    return (Number.isInteger(this.y) ? this.y.toFixed(1) : this.y);
                  }
                }
              },
              series: {
                pointWidth: 30,
                dataLabels: {
                  enabled: true,
                  crop: false,
                  style: {
                    color: 'contrast',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    textOutline: '1px contrast',
                  }
                }
              }
            } as PlotOptions,
            tooltip: {
              enabled: true,
              formatter(): string {
                const { tooltip, name, xAttribute } = this.point['tooltip'] !== undefined
                  ? {
                    tooltip: this.point['tooltip'].split('.')[0],
                    xAttribute: this.point['tooltip'].split('.')[1],
                    name: this.point['tooltip'].split('.')[2]
                  }
                  : { tooltip: this.point.name, name: this.series.name, xAttribute: '' };
                return `
                    <span style="display: block; font-size: 10px">${tooltip}</span><br>
                    <span style="display: block; font-size: 10px">${xAttribute}</span><br>
                    <span style="color: ${this.color}">●</span>
                    <span>${name}:</span>
                    <span style="font-weight: bold">${this.y}</span>
                  `;
              }
            },
            legend: {
              enabled: true,
              symbolRadius: 0
            },
            yAxis: {
              tickPositioner: function () {
                const max = series[0].range.max,
                  min = series[0].range.min;
                return getTickPositions(max, min);
              },
              plotLines: [{ color: '#003399', width: 1.2, value: 0, }],
              title: {
                text: 'SDG %',
                style: {
                  fontWeight: 'bold'
                }
              }
            },
            xAxis: {
              title: {
                text: 'Overall',
                style: {
                  fontWeight: 'bold'
                }
              },
              type: 'category',
              gridLineWidth: 1,
              labels: {
                rotation: 0,
                style: {
                  textOverflow: 'none',
                  min: 0,
                  lineWidth: 4
                },
                formatter() {
                  return typeof this.value !== 'number' ? this.value : '';
                }
              },
              max: (sdgData.length > 0) ? ((sdgData.length >= 5) ? 4 : sdgData.length - 1) : null,
              endOnTick: true,
              scrollbar: {
                enabled: true,
                showFull: false,
                margin: 25
              }
            },
            series,
            drilldown: {
              activeAxisLabelStyle: {
                cursor: 'pointer',
                color: '#003399',
                fontWeight: 'bold',
                textDecoration: 'none',
              },
              activeDataLabelStyle: {
                cursor: 'pointer',
                color: '#003399',
                fontWeight: 'bold',
                textDecoration: 'none',
              },
              allowPointDrilldown: false,
              series: DrilldownData
            } as DrilldownOptions,
            responsive: {
              rules: [
                {
                  condition: {
                    maxWidth: 1200,
                  },
                  chartOptions: {
                    xAxis: {
                      labels: {
                        formatter() {
                          return breakSentenceByWhitespaces(this.value.toString(), 2);
                        },
                      },
                    },
                  },
                },
                {
                  condition: {
                    minWidth: 1200,
                  },
                  chartOptions: {
                    xAxis: {
                      labels: {
                        formatter() {
                          return breakSentenceByWhitespaces(this.value.toString());
                        },
                      },
                    },
                  },
                },
              ],
            },
          });
        }
      })
    );
  }

  private selectEsgUNDevGoalsTable(): Observable<any> {
    // return combineLatest(
    //   this.store.pipe(select(selectEsgSdgData)),
    //   this.sort$,
    //   this.selectedFund$,
    //   this.levelDrillDown$,
    //   this.sdgLevelThreeType$,
    //   this.resetChart$
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectEsgSdgData)),
      this.sort$,
      this.selectedFund$,
      this.levelDrillDown$,
      this.sdgLevelThreeType$,
      this.resetChart$]
    ).pipe(
      map(([esgSdgData, sort, selectedFund, level, type]) => {
        if (!isNullOrUndefined(esgSdgData) && esgSdgData.length > 0) {
          esgSdgData = sort.reverse
            ? this.sort(esgSdgData, sort).reverse()
            : this.sort(esgSdgData, sort);
          return this.generateEsgUNDevGoalsTable(esgSdgData, selectedFund, level, type);
        }
      }),
      distinctUntilChanged(isEqual)
    );
  }


  private generateEsgUNDevGoalsTable(esgSdgData, selectedFund, level, type) {
    const data = [],
      highlighted = [];
    esgSdgData.forEach((record) => {
      if ((!isNullOrUndefined(level) && level === 3)) {
        if (type === 'social') {
          this.esgUNDevGoalsHeader = ESG_UN_DEV_GOALS_HEADER.levelThreeSocial;

          if (selectedFund === record.name) {
            highlighted.push({
              name: record.name,
              level,
              type,
              selected: selectedFund === record.name,
              alleviatingPoverty: record.level3.social.alleviatingPovertyFund,
              attainingGenderEquality: record.level3.social.attainingGenderEqualityFund,
              combatingHunger: record.level3.social.combatingHungerFund,
              deliveringEducation: record.level3.social.deliveringEducationFund,
              ensuringHealth: record.level3.social.ensuringHealthFund,
              providingBasicServices: record.level3.social.providingBasicServicesFund,
              safeguardingPeace: record.level3.social.safeguardingPeaceFund
            });

            highlighted.push({
              parent: record.name,
              name: 'Benchmark',
              level,
              type,
              selected: selectedFund === record.name,
              alleviatingPoverty: record.level3.social.alleviatingPovertyBenchmark,
              attainingGenderEquality: record.level3.social.attainingGenderEqualityBenchmark,
              combatingHunger: record.level3.social.combatingHungerBenchmark,
              deliveringEducation: record.level3.social.deliveringEducationBenchmark,
              ensuringHealth: record.level3.social.ensuringHealthBenchmark,
              providingBasicServices: record.level3.social.providingBasicServicesBenchmark,
              safeguardingPeace: record.level3.social.safeguardingPeaceBenchmark

            });
          } else {
            data.push({
              name: record.name,
              level,
              type,
              selected: selectedFund === record.name,
              alleviatingPoverty: record.level3.social.alleviatingPovertyFund,
              attainingGenderEquality: record.level3.social.attainingGenderEqualityFund,
              combatingHunger: record.level3.social.combatingHungerFund,
              deliveringEducation: record.level3.social.deliveringEducationFund,
              ensuringHealth: record.level3.social.ensuringHealthFund,
              providingBasicServices: record.level3.social.providingBasicServicesFund,
              safeguardingPeace: record.level3.social.safeguardingPeaceFund
            });

            data.push({
              parent: record.name,
              name: 'Benchmark',
              level,
              type,
              selected: selectedFund === record.name,
              alleviatingPoverty: record.level3.social.alleviatingPovertyBenchmark,
              attainingGenderEquality: record.level3.social.attainingGenderEqualityBenchmark,
              combatingHunger: record.level3.social.combatingHungerBenchmark,
              deliveringEducation: record.level3.social.deliveringEducationBenchmark,
              ensuringHealth: record.level3.social.ensuringHealthBenchmark,
              providingBasicServices: record.level3.social.providingBasicServicesBenchmark,
              safeguardingPeace: record.level3.social.safeguardingPeaceBenchmark
            });
          }
        } else if (type === 'environmental') {
          this.esgUNDevGoalsHeader = ESG_UN_DEV_GOALS_HEADER.levelThreeEnvirnomental;
          if (selectedFund === record.name) {
            highlighted.push({
              name: record.name,
              level,
              type,
              selected: selectedFund === record.name,
              achievingSustainableAgricultureAndForests: record.level3.environmental.achievingSustainableAgricultureAndForestsFund,
              conservingWater: record.level3.environmental.conservingWaterFund,
              contributingtoSustainableEnergyUse: record.level3.environmental.contributingtoSustainableEnergyUseFund,
              mitigatingClimateChange: record.level3.environmental.mitigatingClimateChangeFund,
              optimisingMaterialUse: record.level3.environmental.optimisingMaterialUseFund,
              preservingMarineEcosystems: record.level3.environmental.preservingMarineEcosystemsFund,
              preservingTerrestrialEcosystems: record.level3.environmental.preservingTerrestrialEcosystemsFund,
              promotingSustainableBuildings: record.level3.environmental.promotingSustainableBuildingsFund
            });

            highlighted.push({
              parent: record.name,
              name: 'Benchmark',
              level,
              type,
              selected: selectedFund === record.name,
              achievingSustainableAgricultureAndForests: record.level3.environmental.achievingSustainableAgricultureAndForestsBenchmark,
              conservingWater: record.level3.environmental.conservingWaterBenchmark,
              contributingtoSustainableEnergyUse: record.level3.environmental.contributingToSustainableEnergyUseBenchmark,
              mitigatingClimateChange: record.level3.environmental.mitigatingClimateChangeBenchmark,
              optimisingMaterialUse: record.level3.environmental.optimisingMaterialUseBenchmark,
              preservingMarineEcosystems: record.level3.environmental.preservingMarineEcosystemsBenchmark,
              preservingTerrestrialEcosystems: record.level3.environmental.preservingTerrestrialEcosystemsBenchmark,
              promotingSustainableBuildings: record.level3.environmental.promotingSustainableBuildingsBenchmark
            });
          } else {
            data.push({
              name: record.name,
              level,
              type,
              selected: selectedFund === record.name,
              achievingSustainableAgricultureAndForests: record.level3.environmental.achievingSustainableAgricultureAndForestsFund,
              conservingWater: record.level3.environmental.conservingWaterFund,
              contributingtoSustainableEnergyUse: record.level3.environmental.contributingtoSustainableEnergyUseFund,
              mitigatingClimateChange: record.level3.environmental.mitigatingClimateChangeFund,
              optimisingMaterialUse: record.level3.environmental.optimisingMaterialUseFund,
              preservingMarineEcosystems: record.level3.environmental.preservingMarineEcosystemsFund,
              preservingTerrestrialEcosystems: record.level3.environmental.preservingTerrestrialEcosystemsFund,
              promotingSustainableBuildings: record.level3.environmental.promotingSustainableBuildingsFund
            });

            data.push({
              parent: record.name,
              name: 'Benchmark',
              level,
              type,
              selected: selectedFund === record.name,
              achievingSustainableAgricultureAndForests: record.level3.environmental.achievingSustainableAgricultureAndForestsBenchmark,
              conservingWater: record.level3.environmental.conservingWaterBenchmark,
              contributingtoSustainableEnergyUse: record.level3.environmental.contributingToSustainableEnergyUseBenchmark,
              mitigatingClimateChange: record.level3.environmental.mitigatingClimateChangeBenchmark,
              optimisingMaterialUse: record.level3.environmental.optimisingMaterialUseBenchmark,
              preservingMarineEcosystems: record.level3.environmental.preservingMarineEcosystemsBenchmark,
              preservingTerrestrialEcosystems: record.level3.environmental.preservingTerrestrialEcosystemsBenchmark,
              promotingSustainableBuildings: record.level3.environmental.promotingSustainableBuildingsBenchmark
            });
          }
        }

      } else if ((!isNullOrUndefined(level) && level === 2)) {
        this.esgUNDevGoalsHeader = ESG_UN_DEV_GOALS_HEADER.levelTwo;

        if (selectedFund === record.name) {
          highlighted.push({
            name: record.name,
            level,
            selected: selectedFund === record.name,
            social: record.level2.social.socialFund,
            environmental: record.level2.environmental.environmentalFund
          });

          highlighted.push({
            parent: record.name,
            name: 'Benchmark',
            level,
            selected: selectedFund === record.name,
            social: record.level2.social.socialBenchmark,
            environmental: record.level2.environmental.environmentalBenchmark
          });
        } else {
          data.push({
            name: record.name,
            level,
            selected: selectedFund === record.name,
            social: record.level2.social.socialFund,
            environmental: record.level2.environmental.environmentalFund
          });

          data.push({
            parent: record.name,
            name: 'Benchmark',
            level,
            selected: selectedFund === record.name,
            social: record.level2.social.socialBenchmark,
            environmental: record.level2.environmental.environmentalBenchmark
          });
        }

      } else {
        this.esgUNDevGoalsHeader = ESG_UN_DEV_GOALS_HEADER.levelOne;
        data.push({
          name: record.name,
          level,
          overAllFund: record.level1.overAllFund,
        });

        data.push({
          parent: record.name,
          name: 'Benchmark',
          level,
          overAllBenchmark: record.level1.overAllBenchmark,
        });
      }
    });
    const table = [...highlighted, ...data];
    return table;
  }

  public generateTableCF(esgCarbonFootPrint): any {
    const rows = [];
    esgCarbonFootPrint.map(data => {
      const footprintFundObj = {};
      footprintFundObj['name'] = data.name;
      footprintFundObj['secondLastYear'] = data.carbonFootprint.footprintFund.secondLastYear;
      footprintFundObj['lastYear'] = data.carbonFootprint.footprintFund.lastYear;
      footprintFundObj['currentYear'] = data.carbonFootprint.footprintFund.currentYear;
      rows.push(footprintFundObj);

      const footprintBenchmarkObj = {};
      footprintBenchmarkObj['name'] = 'Benchmark';
      footprintBenchmarkObj['secondLastYear'] = data.carbonFootprint.footprintBenchmark.secondLastYear;
      footprintBenchmarkObj['lastYear'] = data.carbonFootprint.footprintBenchmark.lastYear;
      footprintBenchmarkObj['currentYear'] = data.carbonFootprint.footprintBenchmark.currentYear;
      rows.push(footprintBenchmarkObj);
      return rows;
    });
    return rows;
  }

  public getPdfTableRecordDevGoals(sdgData, levelDrillDown, sdgLevelThreeType?) {
    const { pdfTableHeader, pdfData, width } = this.mapColumnsHeadersLevelDrillDown(sdgData, levelDrillDown, sdgLevelThreeType);
    return { pdfTableHeader, pdfData, width };
  }

  public mapData(sdgData, levelDrillDown, sdgLevelThreeType) {
    const rows = [];
    if (levelDrillDown === 0 || levelDrillDown === 1) {
      sdgData.map(data => {
        const fundObj = {},
          benchmarkObj = {};
        fundObj['name'] = data.name;
        fundObj['overall'] = data.level1.overAllFund;
        rows.push(fundObj);
        benchmarkObj['name'] = 'Benchmark';
        benchmarkObj['overall'] = data.level1.overAllBenchmark;
        rows.push(benchmarkObj);
      });
    } else if (levelDrillDown === 2) {
      sdgData.map(data => {
        const fundObj = {},
          benchmarkObj = {};
        fundObj['name'] = data.name;
        fundObj['social'] = data.level2.social.socialFund;
        fundObj['environmental'] = data.level2.environmental.environmentalFund;
        rows.push(fundObj);
        benchmarkObj['name'] = 'Benchmark';
        benchmarkObj['social'] = data.level2.social.socialBenchmark;
        benchmarkObj['environmental'] = data.level2.environmental.environmentalBenchmark;
        rows.push(benchmarkObj);
        return rows;
      });
    } else if (levelDrillDown === 3 && sdgLevelThreeType === 'social') {
      sdgData.map(data => {
        const fundObj = {},
          benchmarkObj = {};
        fundObj['name'] = data.name;
        fundObj['alleviatingPoverty'] = data.level3.social.alleviatingPovertyFund;
        fundObj['attainingGenderEquality'] = data.level3.social.attainingGenderEqualityFund;
        fundObj['combatingHunger'] = data.level3.social.combatingHungerFund;
        fundObj['deliveringEducation'] = data.level3.social.deliveringEducationFund;
        fundObj['ensuringHealth'] = data.level3.social.ensuringHealthFund;
        fundObj['providingBasicServices'] = data.level3.social.providingBasicServicesFund;
        fundObj['safeguardingPeace'] = data.level3.social.safeguardingPeaceFund;
        rows.push(fundObj);
        benchmarkObj['name'] = 'Benchmark';
        benchmarkObj['alleviatingPoverty'] = data.level3.social.alleviatingPovertyBenchmark;
        benchmarkObj['attainingGenderEquality'] = data.level3.social.attainingGenderEqualityBenchmark;
        benchmarkObj['combatingHunger'] = data.level3.social.combatingHungerBenchmark;
        benchmarkObj['deliveringEducation'] = data.level3.social.deliveringEducationBenchmark;
        benchmarkObj['ensuringHealth'] = data.level3.social.ensuringHealthBenchmark;
        benchmarkObj['providingBasicServices'] = data.level3.social.providingBasicServicesBenchmark;
        benchmarkObj['safeguardingPeace'] = data.level3.social.safeguardingPeaceBenchmark;
        rows.push(benchmarkObj);
        return rows;
      });
    } else if (levelDrillDown === 3 && sdgLevelThreeType === 'environmental') {
      sdgData.map(data => {
        const fundObj = {},
          benchmarkObj = {};
        fundObj['name'] = data.name;
        fundObj['conservingWater'] = data.level3.environmental.conservingWaterFund;
        fundObj['achievingSustainableAgricultureAndForests'] = data.level3.environmental.achievingSustainableAgricultureAndForestsFund;
        fundObj['contributingtoSustainableEnergyUse'] = data.level3.environmental.contributingtoSustainableEnergyUseFund;
        fundObj['mitigatingClimateChange'] = data.level3.environmental.mitigatingClimateChangeFund;
        fundObj['optimisingMaterialUse'] = data.level3.environmental.optimisingMaterialUseFund;
        fundObj['preservingMarineEcosystems'] = data.level3.environmental.preservingMarineEcosystemsFund;
        fundObj['preservingTerrestrialEcosystems'] = data.level3.environmental.preservingTerrestrialEcosystemsFund;
        fundObj['promotingSustainableBuildings'] = data.level3.environmental.promotingSustainableBuildingsFund;
        rows.push(fundObj);
        benchmarkObj['name'] = 'Benchmark';
        benchmarkObj['conservingWater'] = data.level3.environmental.conservingWaterBenchmark;
        benchmarkObj['achievingSustainableAgricultureAndForests']
          = data.level3.environmental.achievingSustainableAgricultureAndForestsBenchmark;
        benchmarkObj['contributingtoSustainableEnergyUse'] = data.level3.environmental.contributingToSustainableEnergyUseBenchmark;
        benchmarkObj['mitigatingClimateChange'] = data.level3.environmental.mitigatingClimateChangeBenchmark;
        benchmarkObj['optimisingMaterialUse'] = data.level3.environmental.optimisingMaterialUseBenchmark;
        benchmarkObj['preservingMarineEcosystems'] = data.level3.environmental.preservingMarineEcosystemsBenchmark;
        benchmarkObj['preservingTerrestrialEcosystems'] = data.level3.environmental.preservingTerrestrialEcosystemsBenchmark;
        benchmarkObj['promotingSustainableBuildings'] = data.level3.environmental.promotingSustainableBuildingsBenchmark;
        rows.push(benchmarkObj);
        return rows;
      });
    }

    return rows;
  }

  public mapColumnsHeadersLevelDrillDown(sdgData, levelDrillDown, sdgLevelThreeType) {
    let pdfTableHeader = [],
      pdfData = [],
      width = [];
    const rows = this.mapData(sdgData, levelDrillDown, sdgLevelThreeType);
    pdfData = this.getRowsLevelDrillDown(rows, levelDrillDown, sdgLevelThreeType);
    if (levelDrillDown === 0 || levelDrillDown === 1) {
      pdfTableHeader = ESG_PDF_HEADER.pdfTableHeaderDevGoalsLevel0;
      width = ['auto', 'auto'];
    } else if (levelDrillDown === 2) {
      pdfTableHeader = ESG_PDF_HEADER.pdfTableHeaderDevGoalsLevel2;
      width = ['auto', 'auto', 'auto'];
    } else if (levelDrillDown === 3 && sdgLevelThreeType === 'social') {
      pdfTableHeader = ESG_PDF_HEADER.pdfTableHeaderDevGoalsLevel3Social;
      width = ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
    } else if (levelDrillDown === 3 && sdgLevelThreeType === 'environmental') {
      pdfTableHeader = ESG_PDF_HEADER.pdfTableHeaderDevGoalsLevel3Environmental;
      width = ['auto', '11.5%', '11.5%', '11.5%', '11.5%', '11.5%', '11.5%', '11.5%', '11.5%'];
    }

    return { pdfTableHeader, pdfData, width };
  }

  getRowsLevelDrillDown(rows, levelDrillDown, sdgLevelThreeType) {
    let pdfData = [];
    if (levelDrillDown === 0 || levelDrillDown === 1) {
      pdfData = rows.map(record =>
      ([
        {
          text: !(record.name === 'Benchmark') ? { text: record.name || '-', bold: true } : record.name || '-', style: 'textCell'
        },
        {
          text: record.overall ? record.overall : 'N/A', style: 'numberCell'
        }
      ]
      ));
    } else if (levelDrillDown === 2) {
      pdfData = rows.map(record =>
      ([
        {
          text: !(record.name === 'Benchmark') ? { text: record.name || '-', bold: true } : record.name || '-', style: 'textCell'
        },
        {
          text: record.social ? record.social : 'N/A', style: 'numberCell'
        },
        {
          text: record.environmental ? record.environmental : 'N/A', style: 'numberCell'
        }
      ]
      ));
    } else if (levelDrillDown === 3 && sdgLevelThreeType === 'social') {
      pdfData = rows.map(record =>
      ([
        {
          text: !(record.name === 'Benchmark') ? { text: record.name || '-', bold: true } : record.name || '-', style: 'textCell'
        },
        {
          text: record.alleviatingPoverty ? record.alleviatingPoverty : 'N/A', style: 'numberCell'
        },
        {
          text: record.attainingGenderEquality ? record.attainingGenderEquality : 'N/A', style: 'numberCell'
        },
        {
          text: record.combatingHunger ? record.combatingHunger : 'N/A', style: 'numberCell'
        },
        {
          text: record.deliveringEducation ? record.deliveringEducation : 'N/A', style: 'numberCell'
        },
        {
          text: record.ensuringHealth ? record.ensuringHealth : 'N/A', style: 'numberCell'
        },
        {
          text: record.providingBasicServices ? record.providingBasicServices : 'N/A', style: 'numberCell'
        },
        {
          text: record.safeguardingPeace ? record.safeguardingPeace : 'N/A', style: 'numberCell'
        }
      ]
      ));
    } else if (levelDrillDown === 3 && sdgLevelThreeType === 'environmental') {
      pdfData = rows.map(record =>
      ([
        {
          text: !(record.name === 'Benchmark') ? { text: record.name || '-', bold: true } : record.name || '-', style: 'textCellSI'
        },
        {
          text: record.achievingSustainableAgricultureAndForests
            ? record.achievingSustainableAgricultureAndForests : 'N/A', style: 'numberCellSI'
        },
        {
          text: record.conservingWater ? record.conservingWater : 'N/A', style: 'numberCellSI'
        },
        {
          text: record.contributingtoSustainableEnergyUse ? record.contributingtoSustainableEnergyUse : 'N/A', style: 'numberCellSI'
        },
        {
          text: record.mitigatingClimateChange ? record.mitigatingClimateChange : 'N/A', style: 'numberCellSI'
        },
        {
          text: record.optimisingMaterialUse ? record.optimisingMaterialUse : 'N/A', style: 'numberCellSI'
        },
        {
          text: record.preservingMarineEcosystems ? record.preservingMarineEcosystems : 'N/A', style: 'numberCellSI'
        },
        {
          text: record.preservingTerrestrialEcosystems ? record.preservingTerrestrialEcosystems : 'N/A', style: 'numberCellSI'
        },
        {
          text: record.promotingSustainableBuildings ? record.promotingSustainableBuildings : 'N/A', style: 'numberCellSI'
        }
      ]
      ));
    }

    return pdfData;
  }

  public getPdfTableRecordACTCarbonWeight(analyticsClimateTransitionCarbonWeight) {
    const pdfTableRecord = analyticsClimateTransitionCarbonWeight.map(record =>
    ([
      {
        text: { text: record.name || '-', bold: true }, style: 'textCell'
      },
      {
        text: (record.dgy !== 'N/A')
          ? ((record.dgy > 0)
            ? record.dgy
            : ((record.dgy === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.lgy !== 'N/A')
          ? ((record.lgy > 0)
            ? record.lgy
            : ((record.lgy === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.gyib !== 'N/A')
          ? ((record.gyib > 0)
            ? record.gyib
            : ((record.gyib === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.ib !== 'N/A')
          ? ((record.ib > 0)
            ? record.ib
            : ((record.ib === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.gnib !== 'N/A')
          ? ((record.gnib > 0)
            ? record.gnib
            : ((record.gnib === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.lgn !== 'N/A')
          ? ((record.lgn > 0)
            ? record.lgn
            : ((record.lgn === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.dgn !== 'N/A')
          ? ((record.dgn > 0)
            ? record.dgn
            : ((record.dgn === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.notAssessed !== 'N/A')
          ? ((record.notAssessed > 0)
            ? record.notAssessed
            : ((record.notAssessed === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      }
    ]
    ));
    return pdfTableRecord;
  }

  public getPdfTableRecordACTCarbonIntensity(analyticsClimateTransitionCarbonIntensity) {
    const pdfTableRecord = analyticsClimateTransitionCarbonIntensity.map(record =>
    ([
      {
        text: { text: record.name || '-', bold: true }, style: 'textCell'
      },
      {
        text: (record.dgy !== 'N/A')
          ? ((record.dgy > 0)
            ? this.decimal.transform(record.dgy.toString())
            : ((record.dgy === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.lgy !== 'N/A')
          ? ((record.lgy > 0)
            ? this.decimal.transform(record.lgy.toString())
            : ((record.lgy === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.gyib !== 'N/A')
          ? ((record.gyib > 0)
            ? this.decimal.transform(record.gyib.toString())
            : ((record.gyib === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.ib !== 'N/A')
          ? ((record.ib > 0)
            ? this.decimal.transform(record.ib.toString())
            : ((record.ib === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.gnib !== 'N/A')
          ? ((record.gnib > 0)
            ? this.decimal.transform(record.gnib.toString())
            : ((record.gnib === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.lgn !== 'N/A')
          ? ((record.lgn > 0)
            ? this.decimal.transform(record.lgn.toString())
            : ((record.lgn === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      },
      {
        text: (record.dgn !== 'N/A')
          ? ((record.dgn > 0)
            ? this.decimal.transform(record.dgn.toString())
            : ((record.dgn === 0)
              ? 0 : '-'))
          : 'N/A', style: 'numberCell'
      }
    ]
    ));
    return pdfTableRecord;
  }




  public onExportPDF(type) {
    if (!isNullOrUndefined(type) && type.length > 0) {
      switch (type) {
        case 'modern-slavery':
          return this.onExportModernSlaveryPDF(type);
        case 'diversity-inclusion':
          return this.onExportDiversityInclusionPDF(type);
        case 'proxy-voting':
          return this.onExportProxyVotingPDF(type);
        case 'esg-rating':
          return this.onEsgRatingPDF(type);
        case 'carbon-footprint':
          return this.onExportCarbonFootprintPDF(type);
        case 'climate-transition':
          return this.onExportClimateTransitionPDF(type);
        case 'dev-goals':
          return this.onExportUNDevGoalsPDF(type);

        default:
          return false;
      }
    }
  }
  public onExportCSV(type) {
    if (!isNullOrUndefined(type) && type.length > 0) {
      switch (type) {
        case 'modern-slavery':
          return this.onExportModernSlaveryCSV(type);
        case 'diversity-inclusion':
          return this.onExportDiversionInclusionCSV(type);
        case 'proxy-voting':
          return this.onExportProxyVotingCSV(type);
        case 'esg-rating':
          return this.onExportEsgRatingCSV(type);
        case 'carbon-footprint':
          return this.onExportCarbonFootprintCSV(type);
        case 'climate-transition':
          return this.onExportClimateTransitionCSV(type);
        case 'dev-goals':
          return this.onExportUNDevGoalsCSV(type);

        default:
          return false;
      }
    }
  }

  public onExportModernSlaveryCSV(type) {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate))]
    ).pipe(
      map(([account, client, date]) => ({
        account: !!account ? account._id : undefined,
        accountNumber: !!account ? account.number : undefined,
        accountName: !!account ? account.name : undefined,
        client: client.name,
        date,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      })),
      take(1)
    ).subscribe(payload => {

      // @ts-ignore
      payload = { ...payload, esgType: type };
      let csvName = '';
      if (type === 'modern-slavery') {
        csvName = EsgTabExportName.ModernSlaveryExport;
      }
      // @ts-ignore
      payload = { ...payload, csvName };

      if (!!payload.account) {
        this.store.dispatch(new EsgFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        // this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.", Actions.error);
      }
    });
  }

  public onExportDiversionInclusionCSV(type) {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate))]
    ).pipe(
      map(([account, client, date]) => ({
        account: !!account ? account._id : undefined,
        accountNumber: !!account ? account.number : undefined,
        accountName: !!account ? account.name : undefined,
        client: client.name,
        date,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      })),
      take(1)
    ).subscribe(payload => {

      // @ts-ignore
      payload = { ...payload, esgType: type };
      let csvName = '';
      if (type === 'diversity-inclusion') {
        csvName = EsgTabExportName.DiversityInclusionExport;
      }
      // @ts-ignore
      payload = { ...payload, csvName };

      if (!!payload.account) {
        this.store.dispatch(new EsgFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);

      } else {
        //this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.", Actions.error);
      }
    });
  }

  public onExportProxyVotingCSV(type) {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate))]
    ).pipe(
      map(([account, client, date]) => ({
        account: !!account ? account._id : undefined,
        accountNumber: !!account ? account.number : undefined,
        accountName: !!account ? account.name : undefined,
        client: client.name,
        date,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      })),
      take(1)
    ).subscribe(payload => {

      // @ts-ignore
      payload = { ...payload, esgType: type };
      let csvName = '';
      if (type === 'proxy-voting') {
        csvName = EsgTabExportName.ProxyVotingExport;
      }
      // @ts-ignore
      payload = { ...payload, csvName };

      if (!!payload.account) {
        this.store.dispatch(new EsgFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        //this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.", Actions.error);
      }
    });
  }
  public onExportEsgRatingCSV(type) {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate))]
    ).pipe(
      map(([account, client, date]) => ({
        account: !!account ? account._id : undefined,
        accountNumber: !!account ? account.number : undefined,
        accountName: !!account ? account.name : undefined,
        client: client.name,
        date,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      })),
      take(1)
    ).subscribe(payload => {

      // @ts-ignore
      payload = { ...payload, esgType: type };
      let csvName = '';
      if (type === 'esg-rating') {
        csvName = EsgTabExportName.EsgRatingExport;
      }
      // @ts-ignore
      payload = { ...payload, csvName };

      if (!!payload.account) {
        this.store.dispatch(new EsgFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        //this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.", Actions.error);
      }
    });
  }


  onExportCarbonFootprintCSV(type) {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate))]
    ).pipe(
      map(([account, client, date]) => ({
        account: !!account ? account._id : undefined,
        accountNumber: !!account ? account.number : undefined,
        accountName: !!account ? account.name : undefined,
        client: client.name,
        date,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      // @ts-ignore
      payload = { ...payload, esgType: type };
      let csvName = '';
      if (type === 'carbon-footprint') {
        csvName = EsgTabExportName.CarbonFootprintExport;
      }
      // @ts-ignore
      payload = { ...payload, csvName };

      if (!!payload.account) {
        this.store.dispatch(new EsgFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        //this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.t", Actions.error);
      }
    });
  }
  onExportUNDevGoalsCSV(type) {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    //   this.levelDrillDown$,
    //   this.sdgLevelThreeType$
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.levelDrillDown$,
      this.sdgLevelThreeType$]
    ).pipe(
      map(([account, client, date, levelDrillDown, sdgLevelThreeType]) => ({
        account: !!account ? account._id : undefined,
        accountNumber: !!account ? account.number : undefined,
        accountName: !!account ? account.name : undefined,
        client: client.name,
        date,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country,
        levelDrillDown,
        sdgLevelThreeType
      })),
      take(1)
    ).subscribe(payload => {
      // @ts-ignore
      payload = { ...payload, esgType: type };
      let csvName = '';
      if (type === 'dev-goals') {
        csvName = EsgTabExportName.unDevGoals;
      }
      // @ts-ignore
      payload = { ...payload, csvName };

      if (!!payload.account) {
        this.store.dispatch(new EsgFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        //this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.", Actions.error);
      }
    });
  }

  onExportClimateTransitionCSV(type) {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate))]
    ).pipe(
      map(([account, client, date]) => ({
        account: !!account ? account._id : undefined,
        accountNumber: !!account ? account.number : undefined,
        accountName: !!account ? account.name : undefined,
        client: client.name,
        date,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      // @ts-ignore
      payload = { ...payload, esgType: type };
      let csvName = '';
      if (type === 'climate-transition') {
        csvName = EsgTabExportName.analyticsForClimateTransitionExport;
      }
      // @ts-ignore
      payload = { ...payload, csvName };

      if (!!payload.account) {
        this.store.dispatch(new EsgFileDownloadAction(payload));
      } else if (!payload.account) {
        //this.store.dispatch(new AddErrorToastAction('Please select an Account'));
        return this._toasterService.launchAlertError("Please select an Account", Actions.error);
      } else {
        //this.store.dispatch(new AddErrorToastAction('There is no data in specified date.'));
        return this._toasterService.launchAlertError("There is no data in specified date.", Actions.error);
      }
    });
  }


  public onExportModernSlaveryPDF(type): void {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    //   this.store.pipe(select(selectEsgDate)),
    //   this.store.pipe(select(selectEsgModernSlavery)),
    //   this.store.pipe(select(selectStaticData)),
    //   this.store.pipe(select(selectMainPageNotes)),
    //   this.store.pipe(select(selectConsultants))
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgDate)),
      this.store.pipe(select(selectEsgModernSlavery)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants))]
    ).pipe(
      map(([
        account, client, holdingDate, esgDate, modernSlaveryData, staticData, pageNotes, consultants
      ]) => ({
        account, client: client.name, holdingDate, esgDate, modernSlaveryData, staticData, pageNotes,
        consultants, country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      const { mmcLogo, mercerLogo, icons, promises } = this.staticImages();
      setTimeout(() => {
        Promise.all(promises).then(() => {
          const pageNotes: PageNotes = payload.pageNotes,
            pdfWidth = ['auto', 'auto', 'auto'],
            pdfTableRecord = this.getPdfTableModernSlavery(payload.modernSlaveryData),
            pdfTableHeaderModernSlavery = ESG_PDF_HEADER.pdfTableHeaderModernSlavery,
            address = this.getAddress(payload),
            getStaticData = this.getStaticData(icons, payload),
            getConsultants = this.getConsultantsData(icons, payload),
            getFirstPage = this.getFirstPageData(EsgTabs.modernSlavery, payload),
            getPageNotes = this.getPageNotesData(pageNotes, type),
            docDefinition = {
              content: [
                ...getFirstPage,
                {
                  table: {
                    headerRows: 1,
                    widths: pdfWidth,
                    body: [
                      pdfTableHeaderModernSlavery,
                      ...pdfTableRecord
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                ...getPageNotes,
                ...getConsultants,
                ...getStaticData,
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, EsgTabs.modernSlavery, currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };
          pdfMake.vfs = (pdfFonts.pdfMake as any).vfs;
          pdfMake.createPdf(docDefinition).download(`${EsgTabExportName.ModernSlaveryExport}.pdf`);
        });
      }, 1000);
    });
  }

  public onExportDiversityInclusionPDF(type): void {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    //   this.store.pipe(select(selectEsgDate)),
    //   this.store.pipe(select(selectEsgDiversityAndInclusion)),
    //   this.store.pipe(select(selectStaticData)),
    //   this.store.pipe(select(selectMainPageNotes)),
    //   this.store.pipe(select(selectConsultants))
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgDate)),
      this.store.pipe(select(selectEsgDiversityAndInclusion)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants))]
    ).pipe(
      map(([
        account, client, holdingDate, esgDate, esgDiversityAndInclusionData, staticData, pageNotes, consultants
      ]) => ({
        account, client: client.name, holdingDate, esgDate, esgDiversityAndInclusionData, staticData, pageNotes,
        consultants, country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      const { mmcLogo, mercerLogo, icons, promises } = this.staticImages();
      setTimeout(() => {
        Promise.all(promises).then(() => {
          const pageNotes: PageNotes = payload.pageNotes,
            pdfWidth = ['auto', 'auto', 'auto'],
            pdfTableRecord = this.getPdfTableDiversityInclusion(payload.esgDiversityAndInclusionData),
            pdfTableHeaderDiversityInclusion = ESG_PDF_HEADER.pdfTableHeaderDiversityInclusion,
            address = this.getAddress(payload),
            getStaticData = this.getStaticData(icons, payload),
            getConsultants = this.getConsultantsData(icons, payload),
            getFirstPage = this.getFirstPageData(EsgTabs.diversityInclusion, payload),
            getPageNotes = this.getPageNotesData(pageNotes, type),
            docDefinition = {
              content: [
                ...getFirstPage,
                {
                  table: {
                    headerRows: 1,
                    widths: pdfWidth,
                    body: [
                      pdfTableHeaderDiversityInclusion,
                      ...pdfTableRecord
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                ...getPageNotes,
                ...getConsultants,
                ...getStaticData,
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, EsgTabs.diversityInclusion, currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };
          pdfMake.vfs = (pdfFonts.pdfMake as any).vfs;
          pdfMake.createPdf(docDefinition).download(`${EsgTabExportName.DiversityInclusionExport}.pdf`);
        });
      }, 1000);
    });
  }

  public onExportProxyVotingPDF(type): void {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    //   this.store.pipe(select(selectEsgDate)),
    //   this.store.pipe(select(selectEsgProxyVoting)),
    //   this.store.pipe(select(selectStaticData)),
    //   this.store.pipe(select(selectMainPageNotes)),
    //   this.store.pipe(select(selectConsultants))
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgDate)),
      this.store.pipe(select(selectEsgProxyVoting)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants))]
    ).pipe(
      map(([
        account, client, holdingDate, esgDate,
        esgProxyVoting,
        staticData, pageNotes, consultants
      ]) => ({
        account, client: client.name, holdingDate, esgDate,
        esgProxyVoting,
        staticData, pageNotes,
        consultants, country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      const { mmcLogo, mercerLogo, icons, promises } = this.staticImages();
      setTimeout(() => {
        Promise.all(promises).then(() => {
          const pageNotes: PageNotes = payload.pageNotes,
            pdfWidth = ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            pdfTableRecord = this.getPdfTableProxyVoting(payload.esgProxyVoting),
            pdfTableHeaderProxyVoting = ESG_PDF_HEADER.pdfTableHeaderProxyVoting,
            address = this.getAddress(payload),
            getStaticData = this.getStaticData(icons, payload),
            getConsultants = this.getConsultantsData(icons, payload),
            getFirstPage = this.getFirstPageData(EsgTabs.proxyVoting, payload),
            getPageNotes = this.getPageNotesData(pageNotes, type),
            docDefinition = {
              content: [
                ...getFirstPage,
                {
                  table: {
                    headerRows: 1,
                    widths: pdfWidth,
                    body: [
                      pdfTableHeaderProxyVoting,
                      ...pdfTableRecord
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                ...getPageNotes,
                ...getConsultants,
                ...getStaticData,
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, EsgTabs.proxyVoting, currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };
          pdfMake.vfs = (pdfFonts.pdfMake as any).vfs;
          pdfMake.createPdf(docDefinition).download(`${EsgTabExportName.ProxyVotingExport}.pdf`);
        });
      }, 1000);
    });
  }

  public onEsgRatingPDF(type): void {
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgDate)),
      this.store.pipe(select(selectEsgRatings)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants))]
    ).pipe(
      map(([
        account, client, holdingDate, esgDate,
        esgRating,
        staticData, pageNotes, consultants
      ]) => ({
        account, client: client.name, holdingDate, esgDate,
        esgRating,
        staticData, pageNotes,
        consultants, country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      const { mmcLogo, mercerLogo, icons, promises } = this.staticImages(),
        { esgImg } = this.siImages(type);

      setTimeout(() => {
        Promise.all(promises).then(() => {
          const pageNotes: PageNotes = payload.pageNotes,
            currentYear = formatDate(payload.holdingDate || '', 'MMM YYYY'),
            lastYear = formatDate(moment.utc(payload.holdingDate).subtract(1, 'year').format('YYYY-MM-DD'), 'MMM YYYY'),
            secondLastYear = formatDate(moment.utc(payload.holdingDate).subtract(2, 'year').format('YYYY-MM-DD'), 'MMM YYYY'),
            pdfWidth = ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

            pdfTableRecord = this.getPdfTableEsgRating(payload.esgRating),
            pdfTableHeaderEsgRating = [
              { text: 'Fund Name', style: 'tableHeader' },
              { text: 'Allocation (%)', style: 'tableHeader' },
              { text: 'ESG Rating - ' + secondLastYear, style: 'tableHeader' },
              { text: 'ESG Rating - ' + lastYear, style: 'tableHeader' },
              { text: 'ESG Rating - ' + currentYear, style: 'tableHeader' },
              { text: 'Universe ESG Rating - ' + secondLastYear, style: 'tableHeader' },
              { text: 'Universe ESG Rating - ' + lastYear, style: 'tableHeader' },
              { text: 'Universe ESG Rating - ' + currentYear, style: 'tableHeader' }
            ],
            address = this.getAddress(payload),
            getStaticData = this.getStaticData(icons, payload),
            getConsultants = this.getConsultantsData(icons, payload),
            getFirstPage = this.getFirstPageData(EsgTabs.esgRating, payload),
            getPageNotes = this.getPageNotesData(pageNotes, type),
            docDefinition = {
              content: [
                ...getFirstPage,
                {
                  table: {
                    headerRows: 1,
                    widths: pdfWidth,
                    body: [
                      pdfTableHeaderEsgRating,
                      ...pdfTableRecord
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                ...getPageNotes,
                { text: '', style: 'numberCell', margin: [5, 5] },
                {
                  image: esgImg[0], width: 500,
                  height: 180
                },
                { text: '', style: 'numberCell', margin: [0, 8] },
                {
                  text: 'The Mercer Multi-Manager Fund ratings in this section reflect the weighted average ratings' +
                    ' of the underlying manager strategies that the funds invest in.',
                  style: 'notesData', pageBreak: 'after'
                },
                ...getConsultants,
                ...getStaticData,
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, EsgTabs.esgRating, currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };
          pdfMake.vfs = (pdfFonts.pdfMake as any).vfs;

          pdfMake.createPdf(docDefinition).download(`${EsgTabExportName.EsgRatingExport}.pdf`);
        });
      }, 1000);
    });
  }

  public onExportCarbonFootprintPDF(type): void {
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgDate)),
      this.store.pipe(select(selectEsgCarbonFootPrint)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants))]
    ).pipe(
      map(([
        account, client, holdingDate, esgDate,
        esgCarbonFootprint,
        staticData, pageNotes, consultants
      ]) => ({
        account, client: client.name, holdingDate, esgDate,
        esgCarbonFootprint,
        staticData, pageNotes,
        consultants, country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      const { mmcLogo, mercerLogo, icons, promises } = this.staticImages();
      setTimeout(() => {
        Promise.all(promises).then(() => {
          const pageNotes: PageNotes = payload.pageNotes,
            pdfWidth = ['*', 'auto', 'auto', 'auto'],
            tableRowsData = this.generateTableCF(payload.esgCarbonFootprint),

            pdfTableRecord = this.getPdfTableCarbonFootprint(tableRowsData),
            currentYear = formatDate(payload.holdingDate || '', 'MMM YYYY'),
            lastYear = formatDate(moment.utc(payload.holdingDate).subtract(1, 'year').format('YYYY-MM-DD'), 'MMM YYYY'),
            secondLastYear = formatDate(moment.utc(payload.holdingDate).subtract(2, 'year').format('YYYY-MM-DD'), 'MMM YYYY'),

            pdfTableHeaderCarbonFootprint = [
              { text: 'Fund Name', style: 'tableHeader' },
              { text: `${secondLastYear}`, style: 'tableHeader' },
              { text: `${lastYear}`, style: 'tableHeader' },
              { text: `${currentYear}`, style: 'tableHeader' },
            ],
            address = this.getAddress(payload),
            getStaticData = this.getStaticData(icons, payload),
            getConsultants = this.getConsultantsData(icons, payload),
            getFirstPage = this.getFirstPageData(EsgTabs.carbonFootprint, payload),
            getPageNotes = this.getPageNotesData(pageNotes, type),
            docDefinition = {
              content: [
                ...getFirstPage,
                {
                  table: {
                    headerRows: 1,
                    widths: pdfWidth,
                    body: [
                      pdfTableHeaderCarbonFootprint,
                      ...pdfTableRecord
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                ...getPageNotes,
                ...getConsultants,
                ...getStaticData,
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, EsgTabs.carbonFootprint, currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };
          pdfMake.vfs = (pdfFonts.pdfMake as any).vfs;
          pdfMake.createPdf(docDefinition).download(`${EsgTabExportName.CarbonFootprintExport}.pdf`);
        });
      }, 1000);
    });
  }

  public onExportClimateTransitionPDF(type): void {
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgDate)),
      this.store.pipe(select(selectEsgAnalyticsClimateTransitionCarbonWeight)),
      this.store.pipe(select(selectEsgAnalyticsClimateTransitionDataCarbonIntensity)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants))]
    ).pipe(
      map(([
        account, client, holdingDate, esgDate,
        analyticsClimateTransitionCarbonWeight,
        analyticsClimateTransitionDataCarbonIntensity,
        staticData, pageNotes, consultants
      ]) => ({
        account, client: client.name, holdingDate, esgDate,
        analyticsClimateTransitionCarbonWeight,
        analyticsClimateTransitionDataCarbonIntensity,
        staticData, pageNotes,
        consultants, country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      const { mmcLogo, mercerLogo, icons, promises } = this.staticImages(),
        { esgImg } = this.siImages(type);

      setTimeout(() => {
        Promise.all(promises).then(() => {
          const pageNotes: PageNotes = payload.pageNotes,
            pdfTableRecordACTCarbonWeight = this.getPdfTableRecordACTCarbonWeight(payload.analyticsClimateTransitionCarbonWeight),
            pdfTableRecordACTCarbonIntensity = this.getPdfTableRecordACTCarbonIntensity(
              payload.analyticsClimateTransitionDataCarbonIntensity),
            pdfTableHeaderACTCarbonIntensity = ESG_PDF_HEADER.pdfTableHeaderACTCarbonIntensity,
            pdfTableHeaderACTCarbonWeight = ESG_PDF_HEADER.pdfTableHeaderACTCarbonWeight,
            address = this.getAddress(payload),
            getStaticData = this.getStaticData(icons, payload),
            getConsultants = this.getConsultantsData(icons, payload),
            getFirstPage = this.getFirstPageData(EsgTabs.analyticsForClimateTransition, payload),
            getPageNotes = this.getPageNotesData(pageNotes, type),
            docDefinition = {
              content: [
                ...getFirstPage,
                { text: 'Results by Weight (%)', style: 'textCell', bold: true, margin: [0, 30, 0, 15] },
                {
                  table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                    body: [
                      pdfTableHeaderACTCarbonWeight,
                      ...pdfTableRecordACTCarbonWeight,
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                { text: 'Results by Carbon Intensity (TCO2/$M Rev)', style: 'textCell', bold: true, margin: [0, 30, 0, 15] },
                {
                  table: {
                    headerRows: 1,
                    widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                    body: [
                      pdfTableHeaderACTCarbonIntensity,
                      ...pdfTableRecordACTCarbonIntensity
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                ...getPageNotes,
                { text: '', style: 'numberCell' },
                {
                  image: esgImg[0], width: 500,
                  height: 120
                },
                { text: '', style: 'numberCell', margin: [0, 8] },
                {
                  text: 'ACT will play a key role in supporting Mercer and its clients’ climate transition plans, ' +
                    'in line with commitments to net-zero emissions by 2050.', style: 'notesData'
                },
                { text: '', style: 'numberCell', margin: [0, 8] },

                {
                  text: 'Data source: Mercer proprietary analysis based on data from MSCI ESG Manager and ISS Datadesk',
                  style: 'notesData', pageBreak: 'after'
                },
                ...getConsultants,
                ...getStaticData,
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, EsgTabs.analyticsForClimateTransition, currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };
          pdfMake.vfs = (pdfFonts.pdfMake as any).vfs;
          pdfMake.createPdf(docDefinition).download(`${EsgTabExportName.analyticsForClimateTransitionExport}.pdf`);
        });
      }, 1000);
    });
  }

  public onExportUNDevGoalsPDF(type): void {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.store.pipe(select(selectEsgHoldingDate)),
    //   this.store.pipe(select(selectEsgDate)),
    //   this.store.pipe(select(selectEsgSdgData)),
    //   this.store.pipe(select(selectStaticData)),
    //   this.store.pipe(select(selectMainPageNotes)),
    //   this.store.pipe(select(selectConsultants)),
    //   this.levelDrillDown$,
    //   this.sdgLevelThreeType$
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectEsgHoldingDate)),
      this.store.pipe(select(selectEsgDate)),
      this.store.pipe(select(selectEsgSdgData)),
      this.store.pipe(select(selectStaticData)),
      this.store.pipe(select(selectMainPageNotes)),
      this.store.pipe(select(selectConsultants)),
      this.levelDrillDown$,
      this.sdgLevelThreeType$]
    ).pipe(
      map(([
        account, client, holdingDate, esgDate,
        sdgData,
        staticData, pageNotes, consultants, levelDrillDown, sdgLevelThreeType
      ]) => ({
        account, client: client.name, holdingDate, esgDate,
        sdgData,
        staticData, pageNotes,
        consultants, levelDrillDown, sdgLevelThreeType, country: this.country
      })),
      take(1)
    ).subscribe(payload => {
      const { mmcLogo, mercerLogo, icons, promises } = this.staticImages();
      setTimeout(() => {
        Promise.all(promises).then(() => {
          const pageNotes: PageNotes = payload.pageNotes,
            { pdfTableHeader, pdfData, width } = this.getPdfTableRecordDevGoals(payload.sdgData,
              payload.levelDrillDown, payload.sdgLevelThreeType),
            address = this.getAddress(payload),
            getStaticData = this.getStaticData(icons, payload),
            getConsultants = this.getConsultantsData(icons, payload),
            getFirstPage = this.getFirstPageData(EsgTabs.unDevGoals, payload),
            getPageNotes = this.getPageNotesData(pageNotes, type),
            docDefinition = {
              content: [
                ...getFirstPage,
                {
                  table: {
                    headerRows: 1,
                    widths: width,
                    body: [
                      pdfTableHeader,
                      ...pdfData,
                    ]
                  },
                  layout: {
                    hLineWidth: function (i, node) {
                      return 1;
                    },
                    vLineWidth: function (i, node) {
                      return 1;
                    },
                    hLineColor: function (i, node) {
                      return 'white';
                    },
                    vLineColor: function (i, node) {
                      return 'white';
                    }
                  }
                },
                ...getPageNotes,
                ...getConsultants,
                ...getStaticData,
                ...address
              ],
              styles: {
                ...pdfStyle,
              },
              footer(currentPage: number, totalPages: number) {
                return pdfFooter(currentPage, totalPages, payload, mmcLogo[0]);
              },
              header(currentPage: number, totalPages: number) {
                return pdfHeader(mmcLogo, EsgTabs.unDevGoals, currentPage, totalPages);
              },
              pageMargins: [40, 90, 40, 100]
            };
          pdfMake.vfs = (pdfFonts.pdfMake as any).vfs;
          pdfMake.createPdf(docDefinition).download(`${EsgTabExportName.unDevGoals}.pdf`);
        });
      }, 1000);
    });

  }

  private getPageNotesData(pageNotes, type) {
    const notes = [];
    notes.push({ text: '', style: 'numberCell' });
    notes.push({ text: '', style: 'numberCell' });
    notes.push({ text: '', style: 'numberCell' });
    notes.push({ text: '', style: 'numberCell' });
    notes.push({ text: '', style: 'numberCell' });
    notes.push({ text: '', style: 'numberCell' });

    notes.push({
      text: 'Please contact your consultant to discuss Sustainable Investment Analysis in more detail.',
      color: '#003865', style: 'Esgfootnote'
    });
    notes.push({
      text: 'Analysis may not be available for all funds across all time periods.',
      color: '#003865', style: 'Esgfootnote'
    });
    notes.push({
      text: 'Analysis is available from end June 2021 only.',
      color: '#003865', style: 'Esgfootnote'
    });
    notes.push({
      text: 'The most recently available Sustainable Investment Analysis is displayed as at the analysis month selected.',
      color: '#003865', style: 'Esgfootnote'
    });
    notes.push({ text: CommonConstants.notes, style: 'notesTitle', pageBreak: 'before' });
    switch (type) {
      case 'modern-slavery':
        notes.push({
          text: !isNullOrUndefined(pageNotes.esg.modernSlaveryPdf)
            ? [`${pageNotes.esg.modernSlaveryPdf.split('%')[0].replace(/<br\/>/g, '\n')}`,
            {
              text: pageNotes.esg.modernSlaveryPdf.split('%')[1].replace(/<br\/>/g, '\n'), decoration: 'underline',
              link: EsgPdfLinks.MMCModernSlaveryStatement,
              color: '#005C96'
            },
            { text: pageNotes.esg.modernSlaveryPdf.split('%')[2].replace(/<br\/>/g, '\n') },
            {
              text: pageNotes.esg.modernSlaveryPdf.split('%')[3].replace(/<br\/>/g, '\n'), decoration: 'underline',
              link: EsgPdfLinks.InvestmentApproachModernSlavery,
              color: '#005C96'
            },
            { text: pageNotes.esg.modernSlaveryPdf.split('%')[4].replace(/<br\/>/g, '\n') }
            ]
            : '', style: 'notesData', pageBreak: 'after'
        });
        return notes;
      case 'diversity-inclusion':
        notes.push({
          text: !isNullOrUndefined(pageNotes.esg.diversityInclusion)
            ? `${pageNotes.esg.diversityInclusion.replace(/<br\/>/g, '\n')}`
            : '', style: 'notesData', pageBreak: 'after'
        });
        return notes;
      case 'proxy-voting':
        notes.push({
          text: !isNullOrUndefined(pageNotes.esg.proxyVoting)
            ? `${pageNotes.esg.proxyVoting.replace(/<br\/>/g, '\n')}`
            : '', style: 'notesData', pageBreak: 'after'
        });
        return notes;
      case 'esg-rating':
        notes.push({
          text: !isNullOrUndefined(pageNotes.esg.esgRating)
            ? pageNotes.esg.esgRating
            : '', style: 'notesData'
        });
        return notes;
      case 'carbon-footprint':
        notes.push({
          text: !isNullOrUndefined(pageNotes.esg.carbonFootprint)
            ? `${pageNotes.esg.carbonFootprint.replace(/<br\/>/g, '\n')}`
            : '', style: 'notesData', pageBreak: 'after'
        });
        return notes;
      case 'climate-transition':
        notes.push({
          text: 'The Analytics for Climate Transition (ACT) is a strategic forward-looking assessment of the investment ' +
            'risks and opportunities that are set to arise from a transition to a low carbon economy.',
          style: 'notesData'
        });
        notes.push({ text: '', style: 'numberCell' });
        notes.push({ text: '', style: 'numberCell' });
        notes.push({
          text: 'The transition capacity of a fund is modelled on a spectrum of grey to green investments.',
          style: 'notesData'
        });

        notes.push({ text: '', style: 'numberCell' });
        notes.push({ text: '', style: 'numberCell' });
        notes.push({ text: '', style: 'numberCell' });
        return notes;
      case 'dev-goals':
        notes.push(
          {
            text: 'This analysis measures the net impact that the Mercer Multi-Manager Funds’ underlying investments have' +
              ' on the UN Sustainable Development Goals (SDGs).' +
              ' By being able to measure this impact,' +
              ' investments can actively support the transformation processes required to achieve these environmental and' +
              ' social sustainability goals. ' +
              ' \n \n' +
              'The impact ratings are a reflection of the extent to which revenue generated by a company either' +
              ' contributes or obstructs the achievement of the UN SDGs,' +
              ' as well as accounting for the way the company operates and any controversies linked to it. \n \n' +
              'Data source: ISS Datadesk',
            style: 'notesData',
            pageBreak: 'after'
          }
        );
        return notes;
      default:
        notes.push({
          text: '', style: 'notesData', pageBreak: 'after'
        });
        return notes;
    }

  }

  private getFirstPageData(pdfFor, payload) {
    return [
      { text: pdfFor, style: 'title' },
      { text: '', style: 'subtitle' },
      { text: `Holdings as at end of ${formatDate(payload.holdingDate || '', 'MMM YYYY')}`, style: 'chartTitleNew' },
      { text: `Sustainable Investment Analysis updated in ${formatDate(payload.esgDate || '', 'MMM YYYY')}`, style: 'chartTitleNew' },
      { text: `${payload.client || ''} - ${payload.account.name || ''} - ${payload.account.number || ''}`, style: 'subsubtitle' },
      { text: 'Date Generated: ' + moment().format(CommonConstants.displayDateFormatInAU), style: 'subtitleDate' }
    ];
  }
  private getConsultantsData(icons, payload) {
    return payload.consultants.map(consultant =>
    ([
      { text: `${consultant.firstName} ${consultant.lastName}` || '', style: 'consultantName' },
      {
        columns: [
          // { image: icons['phone'], width: 15, height: 11, margin: [0, 0, 0, 10] },
          { text: `${consultant.phone}` || '', style: 'consultantPhone' }
        ]
      },
      {
        columns: [
          // { image: icons['email'], width: 15, height: 11, margin: [0, 0, 0, 10] },
          { text: `${consultant.username}` || '', style: 'consultantMail' },
        ]
      },
    ]
    ));
  }

  private staticImages() {
    const mmcLogo = [],
      mercerLogo = [],
      icons = [],
      promises = [];
    promises.push(getDataUri('assets/images/mmc_logo.png', CommonConstants.pdfMmcLogoWidth, CommonConstants.pdfMmcLogoHeight)
      .then(data => mmcLogo.push(data)));
    promises.push(getDataUri('assets/images/marsh-logo-rgb-midnight.png', CommonConstants.pdfMercerLogoWidth, CommonConstants.pdfMercerLogoHeight)
      .then(data => mercerLogo.push(data)));
    promises.push(getDataUri('assets/images/phone.png', 18, 18)
      .then(data => icons['phone'] = data));
    promises.push(getDataUri('assets/images/email.png', 18, 18)
      .then(data => icons['email'] = data));
    promises.push(getDataUri('assets/images/website.png', 18, 18)
      .then(data => icons['website'] = data));
    return { mmcLogo, mercerLogo, icons, promises };
  }
  private siImages(type) {
    const esgImg = [],
      promises = [];
    switch (type) {
      case 'esg-rating':
        promises.push(getDataUri('assets/images/esg-rating.jpg', 1996, 269).then(data => esgImg.push(data)));
        return { esgImg, promises };
      case 'climate-transition':
        promises.push(getDataUri('assets/images/esg_analytics_climate_transition.png', 1996, 269).then(data => esgImg.push(data)));
        return { esgImg, promises };
    }
  }


  private getPdfTableModernSlavery(data) {
    const body = data.map(data => {
      const textCellCss = 'textCell',
        numberCellCss = 'numberCell';
      return [
        {
          text: data.name ? { text: data.name || '-', bold: true } : '-', style: textCellCss
        },
        {
          text: (data.companiesRedFlag !== 'N/A')
            ? ((data.companiesRedFlag > 0)
              ? this.decimal.transform(data.companiesRedFlag.toString())
              : ((data.companiesRedFlag === 0)
                ? 0 : '-'))
            : 'N/A', style: numberCellCss
        },
        {
          text: data.porttfolioPercentRedFlag ? data.porttfolioPercentRedFlag : '-', style: numberCellCss
        }
      ];
    });
    return body;

  }

  private getPdfTableDiversityInclusion(data) {
    const body = data.map(data => {
      const textCellCss = 'textCell',
        numberCellCss = 'numberCell';
      return [
        {
          text: data.name ? { text: data.name || '-', bold: true } : '-', style: textCellCss
        },
        {
          text: (data.diBoardDiversityFund) ? data.diBoardDiversityFund : '-', style: numberCellCss
        },
        {
          text: data.diBoardDiversityBenchmark ? data.diBoardDiversityBenchmark : '-', style: numberCellCss
        }
      ];
    });
    return body;

  }

  private getPdfTableCarbonFootprint(data) {
    const pdfTableRecord = data.map(record =>
    ([
      {
        text: !(record.name === 'Benchmark') ? { text: record.name || '-', bold: true } : record.name || '-', style: 'textCell'
      },
      {
        text: record.secondLastYear !== 'N/A'
          ? this.decimal.transform(record.secondLastYear.toString()) : record.secondLastYear || '-', style: 'numberCell'
      },
      {
        text: record.lastYear !== 'N/A'
          ? this.decimal.transform(record.lastYear.toString()) : record.lastYear || '-', style: 'numberCell'
      },
      {
        text: record.currentYear !== 'N/A'
          ? this.decimal.transform(record.currentYear.toString()) : record.currentYear || '-', style: 'numberCell'
      }]
    ));
    return pdfTableRecord;
  }

  private getPdfTableProxyVoting(data) {
    const body = data.map(data => {
      const textCellCss = 'textCell',
        numberCellCss = 'numberCell';
      return [
        {
          text: data.name ? { text: data.name || '-', bold: true } : '-', style: textCellCss
        },
        {
          text: (data.meetingsVotedNumAus !== 'N/A')
            ? ((data.meetingsVotedNumAus > 0)
              ? this.decimal.transform(data.meetingsVotedNumAus.toString())
              : ((data.meetingsVotedNumAus === 0)
                ? 0 : '-'))
            : 'N/A', style: numberCellCss
        }
        ,
        {
          text: data.meetingsVotedPercentAus
            ? data.meetingsVotedPercentAus
            : '-'
          , style: numberCellCss
        },
        {
          text: (data.meetingsVotedNumGlobalExAus !== 'N/A')
            ? ((data.meetingsVotedNumGlobalExAus > 0)
              ? this.decimal.transform(data.meetingsVotedNumGlobalExAus.toString())
              : ((data.meetingsVotedNumGlobalExAus === 0)
                ? 0 : '-'))
            : 'N/A', style: numberCellCss
        },
        {
          text: data.meetingsVotedPercentGlobalExAus
            ? data.meetingsVotedPercentGlobalExAus
            : '-'
          , style: numberCellCss
        },
        {
          text: data.votesAgainstManagementRecPercentGlobal
            ? data.votesAgainstManagementRecPercentGlobal : '-'
          , style: numberCellCss
        },
        {
          text: (data.supervotesNumGlobal !== 'N/A')
            ? ((data.supervotesNumGlobal > 0)
              ? this.decimal.transform(data.supervotesNumGlobal.toString())
              : ((data.supervotesNumGlobal === 0)
                ? 0 : '-'))
            : 'N/A', style: numberCellCss
        },
      ];
    });
    return body;
  }

  private getPdfTableEsgRating(data) {
    const body = data.map(data => {
      const textCellCss = 'textCell',
        numberCellCss = 'numberCell';
      return [
        {
          text: data.name ? { text: data.name || '-', bold: true } : '-', style: textCellCss
        },

        { text: data.allocation.replace('%', '') || '-', style: numberCellCss },
        { text: data.esgRating.ratingFund.secondLastYear || '-', style: numberCellCss },
        { text: data.esgRating.ratingFund.lastYear || '-', style: numberCellCss },
        { text: data.esgRating.ratingFund.currentYear || '-', style: numberCellCss },
        { text: data.esgRating.ratingUniverse.secondLastYear || '-', style: numberCellCss },
        { text: data.esgRating.ratingUniverse.lastYear || '-', style: numberCellCss },
        { text: data.esgRating.ratingUniverse.currentYear || '-', style: numberCellCss },
      ];
    });
    return body;
  }

  private getAddress(payload) {
    const address = [];
    address.push(
      {
        text: !isNullOrUndefined(payload.staticData.entityName) ?
          `${payload.staticData.entityName}` : '', style: 'clientTitle', pageBreak: 'before'
      },
      {
        text: !isNullOrUndefined(payload.staticData.address) ?
          `${payload.staticData.address}` : '', style: 'clientAddress'
      },
    );
    return address;
  }

  private getStaticData(icons, payload) {
    return [{ text: 'Mercer Multi Manager Fund Contact Details', style: 'fundContactTitle' },
    {
      columns: [
        // { image: icons['phone'], width: 15, height: 11, margin: [0, 0, 0, 10] },
        { text: `${payload.staticData.phone || ''}`, style: 'fundContactPhone' }
      ]
    },
    {
      columns: [
        // { image: icons['email'], width: 15, height: 11, margin: [0, 0, 0, 10] },
        { text: `${payload.staticData.email || ''}`, style: 'fundContactEmail' }
      ]
    },
    {
      columns: [
        // { image: icons['website'], width: 15, height: 11, margin: [0, 0, 0, 10] },
        { text: `${payload.staticData.website || ''}`, style: 'fundContactWebsite' }
      ]
    },
    { text: CommonConstants.importantNotices, style: 'noticeTitle', pageBreak: 'before' },
    { text: payload.staticData.importantNotices || '', style: 'noticeData' }];
  }
  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }
}
